import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cardapio-online-admin"
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('button', {
    staticClass: "btn btn-light-dark font-weight-bolder font-size-sm mr-2",
    attrs: {
      "type": "button",
      "disabled": !_vm.managementLoaded || !_vm.config.publicUrl
    },
    on: {
      "click": _vm.copyPublicUrl
    }
  }, [_vm._v(" Copiar link ")]), _c('button', {
    staticClass: "btn btn-light-warning font-weight-bolder font-size-sm mr-2",
    attrs: {
      "type": "button",
      "disabled": !_vm.managementLoaded || !_vm.config.publicUrl
    },
    on: {
      "click": _vm.openPublicPreview
    }
  }, [_vm._v(" Abrir cardápio ")])])]), _c('div', {
    staticClass: "card-body pt-0"
  }, [_vm.managementError ? _c('div', {
    staticClass: "presentation-alert presentation-alert--danger mb-8",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _c('div', [_c('strong', [_vm._v("Não foi possível carregar o Cardápio Digital.")]), _c('p', [_vm._v(" " + _vm._s(_vm.managementError) + " Nenhuma informação demonstrativa está sendo exibida como se fosse configuração real. ")]), _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.loadManagement();
      }
    }
  }, [_vm._v(" Tentar novamente ")])])]) : _vm.managementLoading && !_vm.managementLoaded ? _c('div', {
    staticClass: "presentation-alert presentation-alert--loading mb-8",
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._m(2), _vm._m(3)]) : _vm.managementLoaded ? _c('div', {
    staticClass: "presentation-alert mb-8",
    class: _vm.hubStatus.alertClass,
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "presentation-alert-icon"
  }, [_c('i', {
    class: _vm.hubStatus.icon
  })]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.hubStatus.title))]), _c('p', [_vm._v(_vm._s(_vm.hubStatus.description))])])]) : _vm._e(), _vm.managementLoaded && _vm.activeWorkspace === 'overview' ? _c('div', {
    staticClass: "overview-grid mb-8"
  }, _vm._l(_vm.metrics, function (metric) {
    return _c('div', {
      key: metric.label,
      staticClass: "overview-card"
    }, [_c('span', [_vm._v(_vm._s(metric.label))]), _c('strong', [_vm._v(_vm._s(metric.value))]), _c('small', [_vm._v(_vm._s(metric.hint))])]);
  }), 0) : _vm._e(), _vm.managementLoaded ? _c('div', {
    staticClass: "admin-layout"
  }, [_c('aside', {
    staticClass: "admin-sidebar",
    attrs: {
      "aria-label": "Áreas do Cardápio Digital"
    }
  }, _vm._l(_vm.sections, function (section) {
    return _c('button', {
      key: section.id,
      staticClass: "section-button",
      class: {
        'section-button-active': _vm.activeWorkspace === section.id
      },
      attrs: {
        "type": "button",
        "aria-current": _vm.activeWorkspace === section.id ? 'page' : null
      },
      on: {
        "click": function click($event) {
          return _vm.selectWorkspace(section.id);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(section.label))]), _c('span', [_vm._v(_vm._s(section.description))])]);
  }), 0), _c('main', {
    staticClass: "admin-content"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', [_c('span', {
    staticClass: "text-muted font-weight-bold font-size-sm"
  }, [_vm._v(" " + _vm._s(_vm.currentSection.kicker) + " ")]), _c('h4', [_vm._v(_vm._s(_vm.currentSection.label))]), _c('p', [_vm._v(_vm._s(_vm.currentSection.longDescription))])])]), _vm.currentSection.tabs && _vm.currentSection.tabs.length ? _c('nav', {
    staticClass: "workspace-tabs",
    attrs: {
      "aria-label": "Op\xE7\xF5es de ".concat(_vm.currentSection.label)
    }
  }, _vm._l(_vm.currentSection.tabs, function (tab) {
    return _c('button', {
      key: tab.id,
      staticClass: "workspace-tab",
      class: {
        'workspace-tab--active': _vm.activeSection === tab.id
      },
      attrs: {
        "type": "button",
        "aria-current": _vm.activeSection === tab.id ? 'page' : null
      },
      on: {
        "click": function click($event) {
          return _vm.selectPanel(tab.id);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " ")]);
  }), 0) : _vm._e(), _vm.activeSection === 'overview' ? _c('section', {
    staticClass: "content-grid"
  }, [_c('div', {
    staticClass: "control-card control-card-wide"
  }, [_c('div', {
    staticClass: "brand-preview"
  }, [_vm.logoUrl ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Logo"
    }
  }) : _c('span', {
    staticClass: "brand-preview__fallback"
  }, [_vm._v(" " + _vm._s(_vm.initials(_vm.config.name) || "CD") + " ")]), _c('div', [_c('h5', [_vm._v(_vm._s(_vm.config.name))]), _c('p', [_vm._v(_vm._s(_vm.config.description))]), _c('strong', [_vm._v(_vm._s(_vm.config.publicUrl))])])])]), _c('div', {
    staticClass: "control-card control-card--status"
  }, [_c('div', {
    staticClass: "control-card-top"
  }, [_c('h5', [_vm._v("Cardápio Digital")]), _c('span', {
    staticClass: "label label-inline",
    class: _vm.publicationStatusClass
  }, [_vm._v(" " + _vm._s(_vm.publicationStatusLabel) + " ")])]), _c('strong', {
    class: _vm.channelForm.cardapioDigital ? 'text-success' : 'text-danger'
  }, [_vm._v(" " + _vm._s(_vm.channelForm.cardapioDigital ? "Canal ativo" : "Canal inativo") + " ")]), _c('p', [_vm._v(_vm._s(_vm.config.scheduleLabel))]), _c('small', [_vm._v(_vm._s(_vm.nextChangeLabel))]), _c('div', {
    staticClass: "publishing-actions mt-4"
  }, [!_vm.config.habilitado ? _c('button', {
    staticClass: "btn btn-sm btn-success font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('config') || !_vm.canPublishCardapio,
      "title": _vm.publishBlockingIssues.join(' ')
    },
    on: {
      "click": _vm.publishCardapio
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("config") ? "Salvando..." : "Publicar") + " ")]) : _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('config')
    },
    on: {
      "click": _vm.openCardapioPauseModal
    }
  }, [_vm._v(" Pausar pedidos ")])])]), _c('div', {
    staticClass: "control-card control-card--status"
  }, [_c('div', {
    staticClass: "control-card-top"
  }, [_c('h5', [_vm._v("Self Pedido")]), _c('span', {
    staticClass: "label label-inline",
    class: !_vm.channelForm.selfPedido ? 'label-light-dark' : _vm.selfPedidoReadiness.pronto ? 'label-light-success' : 'label-light-warning'
  }, [_vm._v(" " + _vm._s(!_vm.channelForm.selfPedido ? "Inativo" : _vm.selfPedidoReadiness.pronto ? "Pronto" : "Requer atenção") + " ")])]), _c('strong', {
    class: _vm.channelForm.selfPedido ? 'text-success' : 'text-muted'
  }, [_vm._v(" " + _vm._s(_vm.channelForm.selfPedido ? "Canal ativo" : "Canal inativo") + " ")]), _c('p', [_vm._v("Usa o mesmo catálogo e a mesma identidade visual.")]), _c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.goToOperation('tables');
      }
    }
  }, [_vm._v(" Ambientes, mesas e QR ")])]), _c('div', {
    staticClass: "control-card"
  }, [_c('h5', [_vm._v("Pendências e avisos")]), _c('ul', _vm._l(_vm.pendingAlerts, function (alert) {
    return _c('li', {
      key: alert
    }, [_vm._v(" " + _vm._s(alert) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "control-card control-card-wide"
  }, [_c('h5', [_vm._v("Operação")]), _c('p', [_vm._v(" Configuração e operação têm papéis diferentes. Use estes atalhos para acompanhar pedidos, entregas e mesas. ")]), _c('div', {
    staticClass: "operation-shortcuts"
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.goToOperation('orders');
      }
    }
  }, [_vm._v(" Pedidos Digitais ")]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.goToOperation('deliveries');
      }
    }
  }, [_vm._v(" Entregas no Kanban ")]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.goToOperation('tables');
      }
    }
  }, [_vm._v(" Ambientes e mesas ")])])])]) : _vm.activeSection === 'channels' ? _c('section', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "channel-grid"
  }, [_c('article', {
    staticClass: "channel-card"
  }, [_c('div', {
    staticClass: "channel-card__header"
  }, [_vm._m(4), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.channelForm.cardapioDigital,
      expression: "channelForm.cardapioDigital"
    }],
    attrs: {
      "type": "checkbox",
      "aria-label": "Ativar Cardápio Digital"
    },
    domProps: {
      "checked": Array.isArray(_vm.channelForm.cardapioDigital) ? _vm._i(_vm.channelForm.cardapioDigital, null) > -1 : _vm.channelForm.cardapioDigital
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.channelForm.cardapioDigital,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.channelForm, "cardapioDigital", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.channelForm, "cardapioDigital", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.channelForm, "cardapioDigital", $$c);
        }
      }
    }
  }), _c('span')])])]), _c('p', [_vm._v(" Permite ao cliente comprar pelo link público, usando entrega ou retirada e as formas de pagamento configuradas. ")]), _c('ul', [_vm._l(_vm.cardapioReadiness.bloqueios, function (item) {
    return _c('li', {
      key: "cardapio-".concat(item)
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), !_vm.cardapioReadiness.bloqueios.length ? _c('li', [_vm._v(" Requisitos essenciais atendidos. ")]) : _vm._e()], 2)]), _c('article', {
    staticClass: "channel-card"
  }, [_c('div', {
    staticClass: "channel-card__header"
  }, [_vm._m(5), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.channelForm.selfPedido,
      expression: "channelForm.selfPedido"
    }],
    attrs: {
      "type": "checkbox",
      "aria-label": "Ativar Self Pedido"
    },
    domProps: {
      "checked": Array.isArray(_vm.channelForm.selfPedido) ? _vm._i(_vm.channelForm.selfPedido, null) > -1 : _vm.channelForm.selfPedido
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.channelForm.selfPedido,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.channelForm, "selfPedido", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.channelForm, "selfPedido", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.channelForm, "selfPedido", $$c);
        }
      }
    }
  }), _c('span')])])]), _c('p', [_vm._v(" Usa o catálogo e o tema do Cardápio Digital, mas recebe o pedido pelo QR da mesa e não depende de entrega. ")]), _c('ul', [_vm._l(_vm.selfPedidoReadiness.bloqueios, function (item) {
    return _c('li', {
      key: "self-".concat(item)
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), !_vm.selfPedidoReadiness.bloqueios.length ? _c('li', [_vm._v(" Requisitos essenciais atendidos. ")]) : _vm._e()], 2)])]), _c('div', {
    staticClass: "section-save-bar"
  }, [_vm.channelsDirty ? _c('span', {
    staticClass: "text-warning font-weight-bold"
  }, [_vm._v(" Alterações não salvas ")]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Configuração atualizada")]), _c('div', [_c('button', {
    staticClass: "btn btn-light font-weight-bold mr-2",
    attrs: {
      "type": "button",
      "disabled": !_vm.channelsDirty || _vm.isSaving('channels')
    },
    on: {
      "click": _vm.resetChannelDraft
    }
  }, [_vm._v(" Descartar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": !_vm.channelsDirty || _vm.isSaving('channels')
    },
    on: {
      "click": _vm.saveChannels
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("channels") ? "Salvando..." : "Salvar canais") + " ")])])])]) : _vm.activeSection === 'publishing' ? _c('section', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "publishing-summary"
  }, [_c('div', [_c('span', [_vm._v("Identidade pública")]), _c('strong', [_vm._v(_vm._s(_vm.config.name))]), _c('small', [_vm._v(_vm._s(_vm.config.publicUrl))])]), _c('div', [_c('span', [_vm._v("Horário atual")]), _c('strong', [_vm._v(_vm._s(_vm.config.scheduleLabel || "Não configurado"))]), _c('small', [_vm._v(_vm._s(_vm.config.closedMessage))])]), _c('div', [_c('span', [_vm._v("Situação")]), _c('strong', [_vm._v(_vm._s(_vm.publicationStatusLabel))]), _c('small', [_vm._v(_vm._s(_vm.publicationStatusDescription))])])]), _vm._m(6), _c('div', {
    staticClass: "section-save-bar"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Edite todos estes dados em uma única tela.")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPublishingModal
    }
  }, [_vm._v(" Editar publicação e horários ")])]), _c('div', {
    staticClass: "control-card mt-5"
  }, [_c('div', {
    staticClass: "control-card-top"
  }, [_c('h5', [_vm._v("Checklist de publicação")]), _c('span', {
    staticClass: "label label-inline",
    class: _vm.publicationStatusClass
  }, [_vm._v(" " + _vm._s(_vm.publicationStatusLabel) + " ")])]), _c('p', [_vm._v(_vm._s(_vm.publicationStatusDescription))]), _c('ul', _vm._l(_vm.publicationChecks, function (check) {
    return _c('li', {
      key: check
    }, [_vm._v(" " + _vm._s(check) + " ")]);
  }), 0)])]) : _vm.activeSection === 'catalog' ? _c('section', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_vm._m(7), _c('div', {
    staticClass: "toolbar-actions compact-toolbar-actions"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-light-dark font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToNewProduct
    }
  }, [_vm._v(" Novo produto no cadastro ")]), _c('button', {
    staticClass: "btn btn-sm btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openProductPublisher
    }
  }, [_vm._v(" Publicar produto existente ")])])]), _vm._m(8), _c('div', {
    staticClass: "catalog-summary mb-5"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.publishedProducts.length))]), _vm._v(" publicados ")]), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.candidateProducts.length))]), _vm._v(" disponíveis para publicar ")]), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.unavailableProducts.length))]), _vm._v(" indisponíveis ")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center"
  }, [_vm._m(9), _c('tbody', [_vm._l(_vm.products, function (product) {
    return _c('tr', {
      key: product.id || "source-".concat(product.productId)
    }, [_c('td', [_c('div', {
      staticClass: "product-cell"
    }, [product.imageUrl ? _c('img', {
      attrs: {
        "src": product.imageUrl,
        "alt": product.name
      }
    }) : _c('span', [_vm._v(_vm._s(product.initials))]), _c('div', [_c('strong', [_vm._v(_vm._s(product.name))]), _c('small', [_vm._v(_vm._s(product.description))])])])]), _c('td', [_vm._v(_vm._s(_vm.categoryName(product.categoryId)))]), _c('td', [_vm._v(_vm._s(_vm.formatMoney(product.priceCents)))]), _c('td', [_vm._v(" " + _vm._s(_vm.productPreparationLabel(product)) + " ")]), _c('td', [_c('span', {
      staticClass: "label label-lg label-inline",
      class: product.configured ? 'label-light-primary' : 'label-light-dark'
    }, [_vm._v(" " + _vm._s(product.published ? "Publicado" : product.configured ? "Rascunho" : "Candidato") + " ")]), product.highlighted ? _c('span', {
      staticClass: "label label-lg label-inline label-light-warning ml-2"
    }, [_vm._v(" Destaque ")]) : _vm._e()]), _c('td', [_c('span', {
      staticClass: "label label-lg label-inline",
      class: product.rawAvailable ? 'label-light-success' : 'label-light-danger'
    }, [_vm._v(" " + _vm._s(product.rawAvailable ? "Ativo" : "Pausado") + " ")]), product.rawAvailable && !product.available && product.unavailabilityReasons.length ? _c('small', {
      staticClass: "d-block text-warning mt-1"
    }, [_vm._v(" " + _vm._s(product.unavailabilityReasons.join(" ")) + " ")]) : _vm._e()]), _c('td', {
      staticClass: "text-right"
    }, [product.published ? _c('button', {
      staticClass: "btn btn-sm btn-light font-weight-bold mr-2",
      attrs: {
        "type": "button",
        "disabled": _vm.isSaving('product-status') || !product.id
      },
      on: {
        "click": function click($event) {
          !product.rawAvailable || _vm.isTemporarilyPaused(product) ? _vm.activateProduct(product) : _vm.openPauseModal('product', product);
        }
      }
    }, [_vm._v(" " + _vm._s(!product.id ? "Publicar primeiro" : _vm.isSaving("product-status") ? "Salvando..." : _vm.isTemporarilyPaused(product) ? "Retomar agora" : product.rawAvailable ? "Pausar venda" : "Ativar") + " ")]) : _vm._e(), _c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openCatalogProduct(product);
        }
      }
    }, [_vm._v(" " + _vm._s(product.published ? "Ajustar no site" : product.configured ? "Revisar e publicar" : "Configurar publicação") + " ")])])]);
  }), !_vm.products.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" Nenhum produto foi encontrado. Use “Publicar produto existente” para buscar no estoque. ")])]) : _vm._e()], 2)])])]) : _vm.activeSection === 'categories' ? _c('section', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_vm._m(10), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openCategoryModal();
      }
    }
  }, [_vm._v(" Nova categoria ")])]), _vm._m(11), !_vm.categories.length ? _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Nenhuma categoria cadastrada. ")]) : _c('div', {
    staticClass: "category-row"
  }, _vm._l(_vm.categories, function (category) {
    return _c('div', {
      key: category.id,
      staticClass: "category-chip",
      class: {
        'category-chip--paused': !category.rawAvailable
      }
    }, [_c('strong', [_vm._v(_vm._s(category.name))]), _c('span', [_vm._v(_vm._s(category.count) + " itens")]), _c('small', [_vm._v(_vm._s(category.rawAvailable ? "Disponível" : "Pausada"))]), _c('div', {
      staticClass: "catalog-status-actions"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openCategoryModal(category);
        }
      }
    }, [_vm._v(" Editar ")]), category.rawAvailable ? _c('button', {
      staticClass: "btn btn-xs btn-light-danger font-weight-bold",
      attrs: {
        "type": "button",
        "disabled": _vm.isSaving('category-status') || !category.id
      },
      on: {
        "click": function click($event) {
          return _vm.confirmCategoryImpact(category, false);
        }
      }
    }, [_vm._v(" Pausar venda ")]) : _c('button', {
      staticClass: "btn btn-xs btn-light-success font-weight-bold",
      attrs: {
        "type": "button",
        "disabled": _vm.isSaving('category-status') || !category.id
      },
      on: {
        "click": function click($event) {
          return _vm.confirmCategoryImpact(category, true);
        }
      }
    }, [_vm._v(" Ativar ")])])]);
  }), 0)]) : _vm.activeSection === 'options' ? _c('section', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_vm._m(12), _c('div', {
    staticClass: "toolbar-actions compact-toolbar-actions"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openOptionGroupModal();
      }
    }
  }, [_vm._v(" Novo complemento global ")]), _c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openOptionProductPicker
    }
  }, [_vm._v(" Adicionar a um produto ")])])]), _vm._m(13), !_vm.globalOptionGroups.length ? _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Nenhum grupo de opções cadastrado. ")]) : _c('div', {
    staticClass: "option-admin-list"
  }, _vm._l(_vm.globalOptionGroups, function (group) {
    return _c('article', {
      key: group.id,
      staticClass: "option-admin-card"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(group.nome))]), _c('span', [_vm._v(_vm._s(_vm.optionGroupScopeLabel(group)))]), _c('small', [_vm._v(" " + _vm._s(_vm.optionTypeLabel(group.tipo)) + " · mínimo " + _vm._s(group.minimo) + " · máximo " + _vm._s(group.maximo || "livre") + " ")])]), _c('div', {
      staticClass: "option-admin-items"
    }, _vm._l(group.opcoes, function (option) {
      return _c('div', {
        key: option.id,
        staticClass: "option-admin-item",
        class: {
          'option-admin-item--paused': !option.available
        }
      }, [_c('span', [_vm._v(" " + _vm._s(option.nome) + " "), option.preco_adicional_centavos ? [_vm._v(" · " + _vm._s(_vm.formatMoney(option.preco_adicional_centavos)) + " ")] : _vm._e()], 2), option.available ? _c('button', {
        staticClass: "btn btn-xs btn-clean text-danger p-0",
        attrs: {
          "type": "button",
          "aria-label": "Pausar ".concat(option.nome),
          "disabled": _vm.isSaving('option-item-status')
        },
        on: {
          "click": function click($event) {
            return _vm.openPauseModal('option', option);
          }
        }
      }, [_vm._v(" Pausar ")]) : _vm._e(), !option.available ? _c('button', {
        staticClass: "btn btn-xs btn-clean text-success p-0",
        attrs: {
          "type": "button",
          "aria-label": "Ativar ".concat(option.nome),
          "disabled": _vm.isSaving('option-item-status')
        },
        on: {
          "click": function click($event) {
            return _vm.activateOptionItem(option);
          }
        }
      }, [_vm._v(" Ativar ")]) : _vm._e()]);
    }), 0), _c('div', {
      staticClass: "option-admin-actions"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openOptionGroupModal(group);
        }
      }
    }, [_vm._v(" Editar ")]), _c('button', {
      staticClass: "btn btn-sm btn-light-dark font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.duplicateOptionGroup(group);
        }
      }
    }, [_vm._v(" Duplicar ")]), _c('button', {
      staticClass: "btn btn-sm font-weight-bold",
      class: group.ativo ? 'btn-light-danger' : 'btn-light-success',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleOptionGroup(group);
        }
      }
    }, [_vm._v(" " + _vm._s(group.ativo ? "Pausar" : "Ativar") + " ")])])]);
  }), 0)]) : _vm.activeSection === 'pizzas' ? _c('section', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_vm._m(14), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openVariantCreator
    }
  }, [_vm._v(" Nova variante ")])]), !_vm.pizzas.length && !_vm.globalVariantGroups.length ? _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Nenhuma variante cadastrada. ")]) : _c('div', {
    staticClass: "option-admin-list"
  }, [_vm._l(_vm.globalVariantGroups, function (group) {
    return _c('article', {
      key: "variante-global-".concat(group.id),
      staticClass: "option-admin-card"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(group.nome))]), _c('span', [_vm._v("Variação comercial · " + _vm._s(_vm.optionGroupScopeLabel(group)))]), _c('small', [_vm._v(_vm._s(_vm.optionTypeLabel(group.tipo)) + " · " + _vm._s(group.opcoes.length) + " escolhas")])]), _c('div', {
      staticClass: "option-admin-items"
    }, _vm._l(group.opcoes, function (option) {
      return _c('span', {
        key: "variante-opcao-".concat(option.id),
        staticClass: "label label-inline label-light-primary"
      }, [_vm._v(" " + _vm._s(option.nome) + " ")]);
    }), 0), _c('div', {
      staticClass: "option-admin-actions"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openOptionGroupModal(group);
        }
      }
    }, [_vm._v(" Editar ")]), _c('button', {
      staticClass: "btn btn-sm font-weight-bold",
      class: group.ativo ? 'btn-light-danger' : 'btn-light-success',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleOptionGroup(group);
        }
      }
    }, [_vm._v(" " + _vm._s(group.ativo ? "Pausar" : "Ativar") + " ")])])]);
  }), _vm._l(_vm.pizzas, function (pizza) {
    return _c('article', {
      key: pizza.id,
      staticClass: "option-admin-card"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(pizza.nome_template))]), _c('span', [_vm._v(_vm._s(_vm.productName(pizza.cardapio_produto_id)))]), _c('small', [_vm._v(" " + _vm._s(pizza.tamanhos.length) + " tamanhos · " + _vm._s(pizza.sabores.length) + " sabores · adicional por sabor ")])]), _c('div', {
      staticClass: "option-admin-items"
    }, _vm._l(pizza.tamanhos, function (size) {
      return _c('span', {
        key: size.id || size.localKey,
        staticClass: "label label-inline label-light-primary"
      }, [_vm._v(" " + _vm._s(size.nome) + " · até " + _vm._s(size.max_sabores) + " sabores ")]);
    }), 0), _c('div', {
      staticClass: "option-admin-actions"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openPizzaModal(pizza);
        }
      }
    }, [_vm._v(" Editar ")]), _c('button', {
      staticClass: "btn btn-sm btn-light-dark font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.duplicatePizza(pizza);
        }
      }
    }, [_vm._v(" Duplicar ")]), _c('button', {
      staticClass: "btn btn-sm font-weight-bold",
      class: pizza.ativo ? 'btn-light-danger' : 'btn-light-success',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.togglePizza(pizza);
        }
      }
    }, [_vm._v(" " + _vm._s(pizza.ativo ? "Pausar" : "Ativar") + " ")])])]);
  })], 2)]) : ['promotions', 'coupons', 'combos'].includes(_vm.activeSection) ? _c('section', {
    staticClass: "content-block commercial-section"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_c('div', [_c('h5', [_vm._v(_vm._s(_vm.currentOffer.title))]), _c('p', [_vm._v(_vm._s(_vm.currentOffer.description))])]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCurrentOfferModal
    }
  }, [_vm._v(" " + _vm._s(_vm.currentOffer.actionLabel) + " ")])]), _c('div', {
    staticClass: "commercial-list-grid"
  }, [_vm.activeSection === 'promotions' ? _c('div', {
    staticClass: "commercial-list commercial-list-wide"
  }, [_c('h5', [_vm._v("Campanhas")]), !_vm.promocoes.length ? _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Nenhuma promoção cadastrada. ")]) : _vm._e(), _vm._l(_vm.promocoes, function (promotion) {
    var _promotion$regras, _promotion$regras2;
    return _c('article', {
      key: promotion.id,
      staticClass: "commercial-row",
      class: {
        'commercial-row-with-image': promotion.imagem_url || ((_promotion$regras = promotion.regras) === null || _promotion$regras === void 0 ? void 0 : _promotion$regras.imagem_url)
      }
    }, [promotion.imagem_url || (_promotion$regras2 = promotion.regras) !== null && _promotion$regras2 !== void 0 && _promotion$regras2.imagem_url ? _c('img', {
      staticClass: "commercial-row-image",
      attrs: {
        "src": promotion.imagem_url || promotion.regras.imagem_url,
        "alt": ""
      }
    }) : _vm._e(), _c('div', [_c('strong', [_vm._v(_vm._s(promotion.nome))]), _c('small', [_vm._v(" " + _vm._s(_vm.promotionTargetLabel(promotion)) + " · " + _vm._s(_vm.promotionPeriodLabel(promotion)) + " ")])]), _c('span', {
      staticClass: "label label-inline",
      class: promotion.ativo ? 'label-light-success' : 'label-light-danger'
    }, [_vm._v(" " + _vm._s(promotion.ativo ? "Ativa" : "Pausada") + " ")]), _c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openPromotionModal(promotion);
        }
      }
    }, [_vm._v(" Editar ")])]);
  })], 2) : _vm._e(), _vm.activeSection === 'coupons' ? _c('div', {
    staticClass: "commercial-list commercial-list-wide"
  }, [_c('h5', [_vm._v("Cupons")]), !_vm.cupons.length ? _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Nenhum cupom cadastrado. ")]) : _vm._e(), _vm._l(_vm.cupons, function (coupon) {
    return _c('article', {
      key: coupon.id,
      staticClass: "commercial-row"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(coupon.codigo))]), _c('small', [_vm._v(" " + _vm._s(coupon.nome || "Cupom de desconto") + " · mínimo " + _vm._s(_vm.formatMoney(coupon.pedido_minimo_centavos)) + " ")])]), _c('span', {
      staticClass: "label label-inline",
      class: coupon.ativo ? 'label-light-success' : 'label-light-danger'
    }, [_vm._v(" " + _vm._s(coupon.ativo ? "Ativo" : "Pausado") + " ")]), _c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openCouponModal(coupon);
        }
      }
    }, [_vm._v(" Editar ")])]);
  })], 2) : _vm._e(), _vm.activeSection === 'combos' ? _c('div', {
    staticClass: "commercial-list commercial-list-wide"
  }, [_c('h5', [_vm._v("Combos")]), !_vm.combos.length ? _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Nenhum combo cadastrado. ")]) : _vm._e(), _vm._l(_vm.combos, function (combo) {
    return _c('article', {
      key: combo.id,
      staticClass: "commercial-row"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(combo.nome))]), _c('small', [_vm._v(" " + _vm._s(_vm.productName(combo.cardapio_produto_id)) + " · " + _vm._s(_vm.formatMoney(combo.preco_combo_centavos)) + " ")])]), _c('span', {
      staticClass: "label label-inline",
      class: combo.ativo ? 'label-light-success' : 'label-light-danger'
    }, [_vm._v(" " + _vm._s(combo.ativo ? "Ativo" : "Pausado") + " ")]), _c('b-dropdown', {
      attrs: {
        "right": "",
        "size": "sm",
        "text": "Ações",
        "variant": "light-primary",
        "toggle-class": "font-weight-bold",
        "disabled": _vm.isSaving("combo-status-".concat(combo.id))
      }
    }, [_c('b-dropdown-item-button', {
      on: {
        "click": function click($event) {
          return _vm.openComboModal(combo);
        }
      }
    }, [_vm._v(" Editar ")]), _c('b-dropdown-divider'), _c('b-dropdown-item-button', {
      attrs: {
        "variant": combo.ativo ? 'danger' : 'success'
      },
      on: {
        "click": function click($event) {
          return _vm.toggleCombo(combo);
        }
      }
    }, [_vm._v(" " + _vm._s(combo.ativo ? "Pausar" : "Ativar") + " ")])], 1)], 1);
  })], 2) : _vm._e()])]) : ['delivery', 'pickup', 'checkout'].includes(_vm.activeSection) ? _c('section', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "service-summary-card"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.currentServiceSummary.eyebrow))]), _c('h5', [_vm._v(_vm._s(_vm.currentServiceSummary.title))]), _c('p', [_vm._v(_vm._s(_vm.currentServiceSummary.description))])]), _c('span', {
    staticClass: "label label-lg label-inline",
    class: _vm.currentServiceSummary.enabled ? 'label-light-success' : 'label-light-danger'
  }, [_vm._v(" " + _vm._s(_vm.currentServiceSummary.enabled ? "Ativo" : "Inativo") + " ")])]), _c('div', {
    staticClass: "service-detail-grid"
  }, _vm._l(_vm.currentServiceSummary.details, function (detail) {
    return _c('div', {
      key: detail.label
    }, [_c('span', [_vm._v(_vm._s(detail.label))]), _c('strong', [_vm._v(_vm._s(detail.value))])]);
  }), 0), _c('div', {
    staticClass: "section-save-bar"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.currentServiceSummary.help) + " ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openServiceEditor(_vm.activeSection);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.currentServiceSummary.actionLabel) + " ")])]), _vm.activeSection === 'delivery' ? _c('div', {
    staticClass: "delivery-team-card"
  }, [_c('div', {
    staticClass: "delivery-team-card__header"
  }, [_vm._m(15), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.couriersLoading
    },
    on: {
      "click": _vm.openCourierModal
    }
  }, [_vm._v(" Definir entregador ")])]), _vm.couriersLoading ? _c('div', {
    staticClass: "delivery-team-card__empty",
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v(" Carregando equipe de entrega... ")]) : !_vm.deliveryCouriers.length ? _c('div', {
    staticClass: "delivery-team-card__empty"
  }, [_vm._v(" Nenhum entregador foi vinculado. No cadastro do usuário, marque “Pode atuar como entregador” e volte aqui para ativá-lo. ")]) : _c('div', {
    staticClass: "delivery-team-list"
  }, _vm._l(_vm.deliveryCouriers, function (courier) {
    return _c('div', {
      key: courier.id,
      staticClass: "delivery-team-row"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.courierDisplayName(courier)))]), _c('small', [_vm._v(_vm._s(_vm.courierSecondaryLabel(courier)))])]), _c('div', {
      staticClass: "delivery-team-row__actions"
    }, [_c('span', {
      staticClass: "label label-inline",
      class: courier.ativo ? 'label-light-success' : 'label-light-danger'
    }, [_vm._v(" " + _vm._s(courier.ativo ? "Ativo" : "Pausado") + " ")]), _c('button', {
      staticClass: "btn btn-sm font-weight-bold",
      class: courier.ativo ? 'btn-light-danger' : 'btn-light-success',
      attrs: {
        "type": "button",
        "disabled": _vm.isSaving("courier-".concat(courier.id))
      },
      on: {
        "click": function click($event) {
          return _vm.toggleCourier(courier);
        }
      }
    }, [_vm._v(" " + _vm._s(courier.ativo ? "Pausar" : "Ativar") + " ")])])]);
  }), 0), _c('small', {
    staticClass: "delivery-team-card__permission-note"
  }, [_vm._v(" Para operar a própria entrega, o usuário também precisa da permissão de entrega do sistema. ")])]) : _vm._e()]) : _vm.activeSection === 'visual' ? _c('section', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "appearance-summary"
  }, [_c('div', {
    staticClass: "appearance-summary__brand"
  }, [_vm.logoUrl ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.initials(_vm.config.name) || "CD"))]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.config.name))]), _c('small', [_vm._v(_vm._s(_vm.selectedThemeLabel))])])]), _c('div', {
    staticClass: "appearance-summary__colors"
  }, [_c('span', {
    style: {
      background: _vm.visualForm.primaryColor
    }
  }), _c('span', {
    style: {
      background: _vm.visualForm.accentColor
    }
  }), _c('span', {
    style: {
      background: _vm.visualForm.backgroundColor
    }
  })])]), _c('div', {
    staticClass: "service-detail-grid mt-5"
  }, [_c('div', [_c('span', [_vm._v("Cards")]), _c('strong', [_vm._v(_vm._s(_vm.visualForm.cardStyle === "flat" ? "Limpos" : "Suaves"))])]), _c('div', [_c('span', [_vm._v("Botões")]), _c('strong', [_vm._v(_vm._s(_vm.visualForm.buttonStyle === "pill" ? "Cápsula" : "Arredondados"))])]), _vm._m(16)]), _c('div', {
    staticClass: "section-save-bar"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" A mensagem de loja fechada fica em Publicação; a de checkout, em Pagamentos. Assim cada texto tem uma única fonte. ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openVisualModal
    }
  }, [_vm._v(" Editar aparência e mensagens ")])])]) : _vm._e()])]) : _vm._e()])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioPublishing",
      "title": "Publicação do cardápio",
      "size": "xl",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.cancelPublishing(false);
      }
    }
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Nome exibido no site")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publishingForm.name,
      expression: "publishingForm.name"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "120"
    },
    domProps: {
      "value": _vm.publishingForm.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.publishingForm, "name", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Nome que aparece no topo do cardápio.")]), _vm.fieldError('nome_publico') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("nome_publico")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Slug do link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publishingForm.slug,
      expression: "publishingForm.slug"
    }],
    staticClass: "form-control",
    class: {
      'is-valid': _vm.slugAvailability.status === 'available',
      'is-invalid': _vm.slugAvailability.status === 'unavailable'
    },
    attrs: {
      "maxlength": "80",
      "autocomplete": "off",
      "aria-describedby": "publishing-slug-help publishing-slug-status"
    },
    domProps: {
      "value": _vm.publishingForm.slug
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.publishingForm, "slug", $event.target.value);
      }
    }
  }), _c('small', {
    attrs: {
      "id": "publishing-slug-help"
    }
  }, [_vm._v("Ex.: restaurante-demo.")]), _c('small', {
    staticClass: "slug-availability",
    class: "slug-availability--".concat(_vm.slugAvailability.status),
    attrs: {
      "id": "publishing-slug-status",
      "aria-live": "polite"
    }
  }, [_vm._v(" " + _vm._s(_vm.slugAvailabilityMessage) + " ")]), _vm.publishingPublicUrlPreview ? _c('small', {
    staticClass: "slug-public-url"
  }, [_vm._v(" " + _vm._s(_vm.publishingPublicUrlPreview) + " ")]) : _vm._e(), _vm.fieldError('slug') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("slug")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Descrição curta")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publishingForm.description,
      expression: "publishingForm.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm.publishingForm.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.publishingForm, "description", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Texto curto para orientar o cliente.")]), _vm.fieldError('descricao') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("descricao")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Mensagem de loja fechada")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publishingForm.closedMessage,
      expression: "publishingForm.closedMessage"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm.publishingForm.closedMessage
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.publishingForm, "closedMessage", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Esta é a única mensagem usada pelo site quando a loja estiver fechada.")]), _vm.fieldError('mensagem_fechado') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("mensagem_fechado")) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "weekly-schedule mt-6"
  }, [_c('div', {
    staticClass: "weekly-schedule__head"
  }, [_c('div', [_c('h5', [_vm._v("Agenda semanal")]), _c('p', [_vm._v(" Adicione mais de um período no mesmo dia. Quando o fim for menor ou igual ao início, o horário termina no dia seguinte. ")]), _c('p', [_vm._v(" Publicado mantém o cardápio visível; novos pedidos são liberados somente dentro destes horários. ")])]), _c('small', [_vm._v("Máximo de 6 períodos por dia")])]), _c('div', {
    staticClass: "weekly-schedule__presets",
    attrs: {
      "aria-label": "Atalhos de horário"
    }
  }, [_c('div', [_c('strong', [_vm._v("Repetir o primeiro horário ativo em:")]), _c('small', [_vm._v("Use 24 horas quando não quiser fechamento por agenda.")])]), _c('div', [_c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.applySchedulePreset('all');
      }
    }
  }, [_vm._v(" Todos os dias ")]), _c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.applySchedulePreset('weekdays');
      }
    }
  }, [_vm._v(" Seg a sex ")]), _c('button', {
    staticClass: "btn btn-sm btn-light-success font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.applySchedulePreset('always');
      }
    }
  }, [_vm._v(" 24 horas ")])])]), _c('div', {
    staticClass: "weekly-schedule__summary",
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('span', [_vm._v("Resumo exibido ao cliente")]), _c('strong', [_vm._v(_vm._s(_vm.publishingScheduleSummary || "Nenhum dia aberto"))])]), _vm._l(_vm.publishingForm.weeklyHours, function (day) {
    return _c('article', {
      key: day.dia_semana,
      staticClass: "weekly-day",
      class: {
        'weekly-day--closed': !day.ativo
      }
    }, [_c('div', {
      staticClass: "weekly-day__identity"
    }, [_c('span', {
      staticClass: "switch switch-sm switch-icon switch-success"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: day.ativo,
        expression: "day.ativo"
      }],
      attrs: {
        "type": "checkbox",
        "aria-label": "Abrir ".concat(_vm.weekdayLongLabel(day.dia_semana))
      },
      domProps: {
        "checked": Array.isArray(day.ativo) ? _vm._i(day.ativo, null) > -1 : day.ativo
      },
      on: {
        "change": function change($event) {
          var $$a = day.ativo,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(day, "ativo", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(day, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(day, "ativo", $$c);
          }
        }
      }
    }), _c('span')])]), _c('strong', [_vm._v(_vm._s(_vm.weekdayLongLabel(day.dia_semana)))])]), day.ativo ? _c('div', {
      staticClass: "weekly-day__intervals"
    }, [_vm._l(day.intervalos, function (interval, intervalIndex) {
      return _c('div', {
        key: "".concat(day.dia_semana, "-").concat(intervalIndex),
        staticClass: "weekly-interval"
      }, [_c('label', [_c('span', [_vm._v("Abre")]), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: interval.inicio,
          expression: "interval.inicio"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "time",
          "aria-label": "Abertura de ".concat(_vm.weekdayLongLabel(day.dia_semana), ", per\xEDodo ").concat(intervalIndex + 1)
        },
        domProps: {
          "value": interval.inicio
        },
        on: {
          "input": function input($event) {
            if ($event.target.composing) return;
            _vm.$set(interval, "inicio", $event.target.value);
          }
        }
      })]), _c('label', [_c('span', [_vm._v("Fecha")]), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: interval.fim,
          expression: "interval.fim"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "time",
          "aria-label": "Fechamento de ".concat(_vm.weekdayLongLabel(day.dia_semana), ", per\xEDodo ").concat(intervalIndex + 1)
        },
        domProps: {
          "value": interval.fim
        },
        on: {
          "input": function input($event) {
            if ($event.target.composing) return;
            _vm.$set(interval, "fim", $event.target.value);
          }
        }
      })]), _c('button', {
        staticClass: "btn btn-sm btn-light-danger",
        attrs: {
          "type": "button",
          "disabled": day.intervalos.length === 1,
          "aria-label": "Remover hor\xE1rio de ".concat(_vm.weekdayLongLabel(day.dia_semana))
        },
        on: {
          "click": function click($event) {
            return _vm.removeScheduleInterval(day, intervalIndex);
          }
        }
      }, [_vm._v(" Remover ")])]);
    }), _c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button",
        "disabled": day.intervalos.length >= 6
      },
      on: {
        "click": function click($event) {
          return _vm.addScheduleInterval(day);
        }
      }
    }, [_vm._v(" Adicionar período ")])], 2) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Fechado")])]);
  }), _vm.fieldError('horarios_semanais') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("horarios_semanais")) + " ")]) : _vm._e()], 2), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_vm.publishingDirty ? _c('span', {
    staticClass: "text-warning font-weight-bold mr-auto"
  }, [_vm._v(" Alterações não salvas ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelPublishing
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('config') || !_vm.publishingDirty || _vm.slugAvailability.status === 'checking' || _vm.slugAvailability.status === 'unavailable' || _vm.slugAvailability.status === 'error'
    },
    on: {
      "click": _vm.savePublishing
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("config") ? "Salvando..." : "Salvar publicação") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioPause",
      "title": "Pausar venda",
      "size": "md",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "pause-modal-body"
  }, [_c('div', {
    staticClass: "pause-target-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.pauseForm.typeLabel))]), _c('strong', [_vm._v(_vm._s(_vm.pauseForm.name))]), _c('small', [_vm._v(" Ao pausar, o cliente deixa de comprar este item até a venda ser reativada" + _vm._s(_vm.pauseForm.type === "cardapio" ? "." : " ou até o horário escolhido.") + " ")])]), _vm._l(_vm.visiblePauseOptions, function (option) {
    return _c('label', {
      key: option.value,
      staticClass: "pause-choice",
      class: {
        'pause-choice-active': _vm.pauseForm.mode === option.value
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.pauseForm.mode,
        expression: "pauseForm.mode"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.pauseForm.mode, option.value)
      },
      on: {
        "change": function change($event) {
          return _vm.$set(_vm.pauseForm, "mode", option.value);
        }
      }
    }), _c('span', [_c('strong', [_vm._v(_vm._s(option.label))]), _c('small', [_vm._v(_vm._s(option.description))])])]);
  }), _vm.pauseForm.mode === 'custom' ? _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Data e hora para reativar")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pauseForm.customUntil,
      expression: "pauseForm.customUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": _vm.pauseForm.customUntil
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.pauseForm, "customUntil", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Depois desse horário, a venda volta automaticamente.")])]) : _vm._e(), _vm.pauseForm.type === 'cardapio' ? _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Motivo interno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pauseForm.reason,
      expression: "pauseForm.reason"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "120",
      "placeholder": "Ex.: loja fechada, manutenção, falta de equipe"
    },
    domProps: {
      "value": _vm.pauseForm.reason
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.pauseForm, "reason", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Ajuda a equipe a entender por que o cardápio foi pausado.")])]) : _vm._e(), _vm.pauseForm.type === 'cardapio' ? _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Mensagem para o cliente")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pauseForm.message,
      expression: "pauseForm.message"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "maxlength": "255"
    },
    domProps: {
      "value": _vm.pauseForm.message
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.pauseForm, "message", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Texto exibido no site enquanto o cardápio estiver pausado.")])]) : _vm._e()], 2), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioPause');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-danger font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving(_vm.pauseForm.savingKey)
    },
    on: {
      "click": _vm.confirmPauseTarget
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving(_vm.pauseForm.savingKey) ? "Salvando..." : "Pausar venda") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioDelivery",
      "title": "Entrega",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetDeliveryDraft
    }
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('div', {
    staticClass: "advanced-section-note"
  }, [_c('strong', [_vm._v("Taxa e regiões de entrega")]), _c('span', [_vm._v(" Configure a taxa geral e, quando necessário, valores específicos por bairro ou faixa de CEP. ")])])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Taxa de entrega")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.deliveryForm.feeText,
      callback: function callback($$v) {
        _vm.$set(_vm.deliveryForm, "feeText", $$v);
      },
      expression: "deliveryForm.feeText"
    }
  }, 'money', _vm.moneyOptions, false)), _c('small', [_vm._v("Ex.: R$ 7,00.")]), _vm.fieldError('taxa_entrega_padrao_centavos') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("taxa_entrega_padrao_centavos")) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Pedido mínimo para entrega")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.deliveryForm.minimumText,
      callback: function callback($$v) {
        _vm.$set(_vm.deliveryForm, "minimumText", $$v);
      },
      expression: "deliveryForm.minimumText"
    }
  }, 'money', _vm.moneyOptions, false)), _c('small', [_vm._v("Ex.: R$ 25,00.")]), _vm.fieldError('pedido_minimo_centavos') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("pedido_minimo_centavos")) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tempo mínimo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.deliveryForm.minMinutes,
      expression: "deliveryForm.minMinutes",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1440"
    },
    domProps: {
      "value": _vm.deliveryForm.minMinutes
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.deliveryForm, "minMinutes", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('small', [_vm._v("Tempo mínimo em minutos.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tempo máximo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.deliveryForm.maxMinutes,
      expression: "deliveryForm.maxMinutes",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1440"
    },
    domProps: {
      "value": _vm.deliveryForm.maxMinutes
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.deliveryForm, "maxMinutes", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('small', [_vm._v("Tempo máximo em minutos.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Entrega ativa")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.deliveryForm.deliveryEnabled,
      expression: "deliveryForm.deliveryEnabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.deliveryForm.deliveryEnabled) ? _vm._i(_vm.deliveryForm.deliveryEnabled, null) > -1 : _vm.deliveryForm.deliveryEnabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.deliveryForm.deliveryEnabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.deliveryForm, "deliveryEnabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.deliveryForm, "deliveryEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.deliveryForm, "deliveryEnabled", $$c);
        }
      }
    }
  }), _c('span')])]), _c('small', [_vm._v("Mostra entrega como opção no checkout.")])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Endereço do restaurante")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.deliveryForm.baseAddress,
      expression: "deliveryForm.baseAddress"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.deliveryForm.baseAddress
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.deliveryForm, "baseAddress", $event.target.value);
      }
    }
  }), _c('small', [_vm._v(" Informe rua, número, bairro, cidade e UF. A entrega é cotada pelo endereço, bairro ou CEP informado pelo cliente. ")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Resumo")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.deliveryPreviewLabel
    }
  }), _c('small', [_vm._v("Conferência dos valores exibidos ao cliente.")])])]), _c('div', {
    staticClass: "delivery-zones"
  }, [_c('div', {
    staticClass: "delivery-zones__head"
  }, [_c('div', [_c('strong', [_vm._v("Zonas por bairro/CEP (opcional)")]), _c('small', [_vm._v(" Defina taxa, pedido mínimo e tempo por bairro ou faixa de CEP. Endereços fora das zonas usam a taxa única acima. ")])]), _c('button', {
    staticClass: "btn btn-sm btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newZone
    }
  }, [_vm._v(" Adicionar zona ")])]), !_vm.deliveryZones.length ? _c('p', {
    staticClass: "delivery-zones__empty"
  }, [_vm._v(" Nenhuma zona cadastrada. A taxa única vale para toda a área atendida. ")]) : _c('ul', {
    staticClass: "delivery-zones__list"
  }, _vm._l(_vm.deliveryZones, function (zone) {
    return _c('li', {
      key: zone.id,
      staticClass: "delivery-zones__item"
    }, [_c('div', {
      staticClass: "delivery-zones__info"
    }, [_c('strong', [_vm._v(_vm._s(zone.nome))]), _c('small', [_vm._v(_vm._s(_vm.zoneScopeLabel(zone)))]), _c('small', [_vm._v(" Taxa " + _vm._s(_vm.moneyTextFromCents(zone.taxa_entrega_centavos)) + " · mín. " + _vm._s(_vm.moneyTextFromCents(zone.pedido_minimo_centavos)) + " "), zone.bloqueada ? [_vm._v(" · bloqueada")] : !zone.ativo ? [_vm._v(" · inativa")] : _vm._e()], 2)]), _c('div', {
      staticClass: "delivery-zones__actions"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-light",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editZone(zone);
        }
      }
    }, [_vm._v(" Editar ")]), _c('button', {
      staticClass: "btn btn-sm btn-light",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleZone(zone);
        }
      }
    }, [_vm._v(" " + _vm._s(zone.ativo ? "Desativar" : "Ativar") + " ")]), _c('button', {
      staticClass: "btn btn-sm btn-light text-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteZone(zone);
        }
      }
    }, [_vm._v(" Excluir ")])])]);
  }), 0), _vm.zoneForm.open ? _c('div', {
    staticClass: "delivery-zones__form modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('strong', [_vm._v(_vm._s(_vm.zoneForm.id ? "Editar zona" : "Nova zona"))])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Nome da zona")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zoneForm.nome,
      expression: "zoneForm.nome"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.zoneForm.nome
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.zoneForm, "nome", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Bairro")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zoneForm.bairro,
      expression: "zoneForm.bairro"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.zoneForm.bairro
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.zoneForm, "bairro", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Casa pelo nome do bairro informado pelo cliente.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("CEP inicial")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zoneForm.cepInicio,
      expression: "zoneForm.cepInicio"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.zoneForm.cepInicio
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.zoneForm, "cepInicio", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("CEP final")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zoneForm.cepFim,
      expression: "zoneForm.cepFim"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.zoneForm.cepFim
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.zoneForm, "cepFim", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Preencha bairro OU faixa de CEP.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Taxa de entrega")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.zoneForm.feeText,
      callback: function callback($$v) {
        _vm.$set(_vm.zoneForm, "feeText", $$v);
      },
      expression: "zoneForm.feeText"
    }
  }, 'money', _vm.moneyOptions, false))], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Pedido mínimo")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.zoneForm.minimumText,
      callback: function callback($$v) {
        _vm.$set(_vm.zoneForm, "minimumText", $$v);
      },
      expression: "zoneForm.minimumText"
    }
  }, 'money', _vm.moneyOptions, false))], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Frete grátis acima de")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.zoneForm.freeAboveText,
      callback: function callback($$v) {
        _vm.$set(_vm.zoneForm, "freeAboveText", $$v);
      },
      expression: "zoneForm.freeAboveText"
    }
  }, 'money', _vm.moneyOptions, false)), _c('small', [_vm._v("Deixe R$ 0,00 quando não houver.")])], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tempo mínimo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.zoneForm.minMinutes,
      expression: "zoneForm.minMinutes",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.zoneForm.minMinutes
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.zoneForm, "minMinutes", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tempo máximo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.zoneForm.maxMinutes,
      expression: "zoneForm.maxMinutes",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.zoneForm.maxMinutes
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.zoneForm, "maxMinutes", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Bloquear esta zona")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-danger"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.zoneForm.bloqueada,
      expression: "zoneForm.bloqueada"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.zoneForm.bloqueada) ? _vm._i(_vm.zoneForm.bloqueada, null) > -1 : _vm.zoneForm.bloqueada
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.zoneForm.bloqueada,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.zoneForm, "bloqueada", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.zoneForm, "bloqueada", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.zoneForm, "bloqueada", $$c);
        }
      }
    }
  }), _c('span')])]), _c('small', [_vm._v("Recusa entregas para o bairro/CEP.")])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide delivery-zones__form-actions"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelZone
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('delivery-zone')
    },
    on: {
      "click": _vm.saveZone
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("delivery-zone") ? "Salvando..." : "Salvar zona") + " ")])])]) : _vm._e()]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_vm.deliveryDirty ? _c('span', {
    staticClass: "text-warning font-weight-bold mr-auto"
  }, [_vm._v(" Alterações não salvas ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelDelivery
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('delivery')
    },
    on: {
      "click": _vm.saveDelivery
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("delivery") ? "Salvando..." : "Salvar entrega") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioCourier",
      "title": "Definir entregador",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetCourierForm
    }
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('div', {
    staticClass: "advanced-section-note"
  }, [_c('strong', [_vm._v("Vincule um usuário existente")]), _c('span', [_vm._v(" Somente usuários ativos com “Pode atuar como entregador” aparecem nesta lista. Ao vincular, o usuário poderá receber atribuições nos Pedidos Digitais e acessar a aba Entregas no aplicativo. ")])])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', {
    attrs: {
      "for": "cardapio-courier-user"
    }
  }, [_vm._v("Usuário")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.courierForm.usuarioId,
      expression: "courierForm.usuarioId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cardapio-courier-user",
      "disabled": _vm.courierUsersLoading
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.courierForm, "usuarioId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.courierUsersLoading ? "Carregando usuários..." : _vm.courierUserOptions.length ? "Selecione um usuário habilitado" : "Nenhum usuário habilitado disponível") + " ")]), _vm._l(_vm.courierUserOptions, function (option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  })], 2), _vm.fieldError('usuario_id') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("usuario_id")) + " ")]) : !_vm.courierUsersLoading && !_vm.courierUserOptions.length ? _c('small', [_vm._v(" Habilite a função no cadastro do usuário para que ele apareça aqui. ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', {
    attrs: {
      "for": "cardapio-courier-name"
    }
  }, [_vm._v("Nome exibido")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.courierForm.displayName,
      expression: "courierForm.displayName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cardapio-courier-name",
      "maxlength": "120",
      "placeholder": "Opcional"
    },
    domProps: {
      "value": _vm.courierForm.displayName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.courierForm, "displayName", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Se vazio, será usado o nome do usuário.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', {
    attrs: {
      "for": "cardapio-courier-phone"
    }
  }, [_vm._v("Telefone operacional")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.courierForm.phone,
      expression: "courierForm.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cardapio-courier-phone",
      "maxlength": "30",
      "inputmode": "tel",
      "placeholder": "Opcional"
    },
    domProps: {
      "value": _vm.courierForm.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.courierForm, "phone", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bold mr-auto",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('courier')
    },
    on: {
      "click": _vm.openCourierUsers
    }
  }, [_vm._v(" Abrir cadastro de usuários ")]), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('courier')
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioCourier');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('courier') || _vm.courierUsersLoading || !_vm.courierForm.usuarioId
    },
    on: {
      "click": _vm.saveCourier
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("courier") ? "Vinculando..." : "Vincular usuário") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioPickup",
      "title": "Retirada",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetDeliveryDraft
    }
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Permitir retirada no balcão")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.deliveryForm.pickupEnabled,
      expression: "deliveryForm.pickupEnabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.deliveryForm.pickupEnabled) ? _vm._i(_vm.deliveryForm.pickupEnabled, null) > -1 : _vm.deliveryForm.pickupEnabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.deliveryForm.pickupEnabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.deliveryForm, "pickupEnabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.deliveryForm, "pickupEnabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.deliveryForm, "pickupEnabled", $$c);
        }
      }
    }
  }), _c('span')])]), _c('small', [_vm._v("Retirada não pede endereço do cliente.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tempo de preparo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.deliveryForm.pickupMinutes,
      expression: "deliveryForm.pickupMinutes",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.deliveryForm.pickupMinutes
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.deliveryForm, "pickupMinutes", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('small', [_vm._v("Estimativa mostrada para retirada.")])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Instrução para o cliente")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.deliveryForm.pickupMessage,
      expression: "deliveryForm.pickupMessage"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "maxlength": "500"
    },
    domProps: {
      "value": _vm.deliveryForm.pickupMessage
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.deliveryForm, "pickupMessage", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Ex.: retire no balcão informando o código do pedido.")]), _vm.fieldError('mensagem') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("mensagem")) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_vm.deliveryDirty ? _c('span', {
    staticClass: "text-warning font-weight-bold mr-auto"
  }, [_vm._v(" Alterações não salvas ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelPickup
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('pickup')
    },
    on: {
      "click": _vm.savePickup
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("pickup") ? "Salvando..." : "Salvar retirada") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioProduct",
      "title": "Produto no site",
      "size": "xl",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeProductDraft
    }
  }, [_vm.productForm ? _c('div', [_c('div', {
    staticClass: "product-modal-header"
  }, [_c('div', {
    staticClass: "product-photo-preview product-photo-preview-sm"
  }, [_vm.productForm.imagePreviewUrl || _vm.productForm.imageUrl ? _c('img', {
    attrs: {
      "src": _vm.productForm.imagePreviewUrl || _vm.productForm.imageUrl,
      "alt": _vm.productForm.name
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.productForm.initials))])]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.productForm.name))]), _c('small', [_vm._v(_vm._s(_vm.categoryName(_vm.productForm.categoryId)))])])]), _c('div', {
    staticClass: "product-tabs"
  }, _vm._l(_vm.productTabs, function (tab) {
    return _c('button', {
      key: tab.value,
      class: {
        'product-tab-active': _vm.productForm.activeTab === tab.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.productForm.activeTab = tab.value;
        }
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " ")]);
  }), 0), _vm.productForm.activeTab === 'data' ? _c('div', {
    staticClass: "product-modal-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Nome no site")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.productForm.name,
      expression: "productForm.name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.productForm.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.productForm, "name", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Nome curto e claro para o cliente.")]), _vm.fieldError('nome_publico') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("nome_publico")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Categoria")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.productForm.categoryId,
      expression: "productForm.categoryId"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.productForm, "categoryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.categories, function (category) {
    return _c('option', {
      key: category.id,
      domProps: {
        "value": category.id
      }
    }, [_vm._v(" " + _vm._s(category.name) + " ")]);
  }), 0), _c('small', [_vm._v("Define onde aparece no cardápio.")]), _c('button', {
    staticClass: "btn btn-link btn-sm pl-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openCategoryModal(null, false, true);
      }
    }
  }, [_vm._v(" + Nova categoria ")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Preço exibido")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.productForm.priceText,
      callback: function callback($$v) {
        _vm.$set(_vm.productForm, "priceText", $$v);
      },
      expression: "productForm.priceText"
    }
  }, 'money', _vm.moneyOptions, false)), _c('small', [_vm._v("Ex.: R$ 29,90.")]), _vm.fieldError('preco_centavos') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("preco_centavos")) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Descrição")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.productForm.description,
      expression: "productForm.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": _vm.productForm.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.productForm, "description", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Texto que aparece no card e no detalhe.")])])]) : _vm._e(), _vm.productForm.activeTab === 'photo' ? _c('div', {
    staticClass: "product-media-panel"
  }, [_c('div', {
    staticClass: "product-photo-preview product-photo-preview-lg"
  }, [_vm.productForm.imagePreviewUrl || _vm.productForm.imageUrl ? _c('img', {
    attrs: {
      "src": _vm.productForm.imagePreviewUrl || _vm.productForm.imageUrl,
      "alt": _vm.productForm.name
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.productForm.initials))])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Foto do produto")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg,image/png,image/webp"
    },
    on: {
      "change": _vm.onProductImageSelected
    }
  }), _c('small', [_vm._v(" JPG, PNG ou WebP, até 5 MB. A foto aparece no cardápio. ")]), _vm.fieldError('imagem') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("imagem")) + " ")]) : _vm._e()])]) : _vm._e(), _vm.productForm.activeTab === 'options' ? _c('div', {
    staticClass: "product-config-panel"
  }, [_c('div', {
    staticClass: "guided-option-panel"
  }, [_c('div', [_c('strong', [_vm._v("Adicionar escolhas deste produto")]), _c('p', [_vm._v(" Escolha o tipo de personalização e o formulário já vem com exemplos prontos para editar. ")])]), _c('div', {
    staticClass: "guided-option-grid"
  }, _vm._l(_vm.optionGroupPresets, function (preset) {
    return _c('button', {
      key: "product-".concat(preset.key),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openProductOptionGroupModal(_vm.productForm, preset.key);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(preset.label))]), _c('span', [_vm._v(_vm._s(preset.short))])]);
  }), 0)]), _c('div', {
    staticClass: "toolbar-line"
  }, [_c('div', [_c('h5', [_vm._v("Opções deste produto")]), _c('p', [_vm._v(" Cadastre aqui borda, adicionais, remoções e acompanhamentos que pertencem somente a este produto. ")])]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openProductOptionGroupModal(_vm.productForm);
      }
    }
  }, [_vm._v(" Novo grupo ")])]), !_vm.productOptionGroups(_vm.productForm).length ? _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Nenhum grupo exclusivo deste produto. ")]) : _c('div', {
    staticClass: "product-linked-list"
  }, _vm._l(_vm.productOptionGroups(_vm.productForm), function (group) {
    return _c('article', {
      key: group.id
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(group.nome))]), _c('small', [_vm._v(" " + _vm._s(_vm.optionTypeLabel(group.tipo)) + " · " + _vm._s(group.opcoes.length) + " opções ")])]), _c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.openOptionGroupModal(group);
        }
      }
    }, [_vm._v(" Editar ")])]);
  }), 0)]) : _vm._e(), _vm.productForm.activeTab === 'pizza' ? _c('div', {
    staticClass: "product-config-panel"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_c('div', [_c('h5', [_vm._v("Variante")]), _c('p', [_vm._v(" Use quando este produto precisar de tamanho e sabores antes de ir para o carrinho. ")])]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openProductPizzaModal(_vm.productForm);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.productPizzaTemplate(_vm.productForm) ? "Editar variante" : "Ativar variante") + " ")])]), _vm.productPizzaTemplate(_vm.productForm) ? _c('div', {
    staticClass: "product-linked-list"
  }, [_c('article', [_c('div', [_c('strong', [_vm._v(" " + _vm._s(_vm.productPizzaTemplate(_vm.productForm).nome_template) + " ")]), _c('small', [_vm._v(" " + _vm._s(_vm.productPizzaTemplate(_vm.productForm).tamanhos.length) + " tamanhos · " + _vm._s(_vm.productPizzaTemplate(_vm.productForm).sabores.length) + " sabores ")])]), _c('span', {
    staticClass: "label label-inline",
    class: _vm.productPizzaTemplate(_vm.productForm).ativo ? 'label-light-success' : 'label-light-danger'
  }, [_vm._v(" " + _vm._s(_vm.productPizzaTemplate(_vm.productForm).ativo ? "Ativa" : "Pausada") + " ")])])]) : _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Este produto ainda usa o fluxo comum de compra. ")])]) : _vm._e(), _vm.productForm.activeTab === 'promotion' ? _c('div', {
    staticClass: "product-config-panel"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_c('div', [_c('h5', [_vm._v("Promoção")]), _c('p', [_vm._v(" Marque o produto como destaque agora. A vitrine comercial completa fica na seção Promoções. ")])]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openProductPromotionModal(_vm.productForm);
      }
    }
  }, [_vm._v(" Abrir promoções ")])]), _c('label', {
    staticClass: "highlight-toggle-card"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.productForm.highlighted,
      expression: "productForm.highlighted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.productForm.highlighted) ? _vm._i(_vm.productForm.highlighted, null) > -1 : _vm.productForm.highlighted
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.productForm.highlighted,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.productForm, "highlighted", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.productForm, "highlighted", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.productForm, "highlighted", $$c);
        }
      }
    }
  }), _c('span', [_c('strong', [_vm._v("Destacar no cardápio")]), _c('small', [_vm._v("Aparece em destaques e sugestões do site.")])])])]) : _vm._e(), _vm.productForm.activeTab === 'availability' ? _c('div', {
    staticClass: "product-config-panel"
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Disponível no site")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.productForm.available,
      expression: "productForm.available"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.productForm.available) ? _vm._i(_vm.productForm.available, null) > -1 : _vm.productForm.available
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.productForm.available,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.productForm, "available", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.productForm, "available", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.productForm, "available", $$c);
        }
      }
    }
  }), _c('span')])]), _c('small', [_vm._v(" Use para pausar temporariamente sem apagar o produto. ")]), _vm.productForm.rawAvailable && !_vm.productForm.effectiveAvailable && _vm.productForm.unavailabilityReasons.length ? _c('small', {
    staticClass: "d-block mt-2 text-warning"
  }, [_vm._v(" " + _vm._s(_vm.productForm.unavailabilityReasons.join(" ")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Preparo")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.productPreparationLabel(_vm.productForm)
    }
  }), _c('small', [_vm._v("O setor vem do cadastro operacional do produto.")])])])]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioProduct');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-light-dark font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToProducts
    }
  }, [_vm._v(" Abrir cadastro oficial ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('product')
    },
    on: {
      "click": _vm.saveProduct
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("product") ? "Salvando..." : "Salvar produto") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioProductPublisher",
      "title": "Publicar produto do estoque",
      "size": "xl",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetProductPublisher
    }
  }, [!_vm.publicationForm ? _c('div', [_c('div', {
    staticClass: "stock-search-toolbar"
  }, [_c('div', {
    staticClass: "modal-control-field stock-search-toolbar__query"
  }, [_c('label', {
    attrs: {
      "for": "cardapio-stock-search"
    }
  }, [_vm._v("Buscar no estoque")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.stockSearch.q,
      expression: "stockSearch.q",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cardapio-stock-search",
      "placeholder": "Nome, código ou código de barras"
    },
    domProps: {
      "value": _vm.stockSearch.q
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.loadStockProducts(1);
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.stockSearch, "q", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Categoria")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.stockSearch.grupo_id,
      expression: "stockSearch.grupo_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.stockSearch, "grupo_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._l(_vm.categories, function (category) {
    return _c('option', {
      key: "estoque-grupo-".concat(category.id),
      domProps: {
        "value": category.grupoId
      }
    }, [_vm._v(" " + _vm._s(category.name) + " ")]);
  })], 2)]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Uso no restaurante")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.stockSearch.restaurante,
      expression: "stockSearch.restaurante"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.stockSearch, "restaurante", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Já habilitados")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Ainda não habilitados")])])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.stockSearch.ativo,
      expression: "stockSearch.ativo"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.stockSearch, "ativo", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ativos e inativos")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativos")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativos")])])]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold stock-search-toolbar__button",
    attrs: {
      "type": "button",
      "disabled": _vm.stockLoading
    },
    on: {
      "click": function click($event) {
        return _vm.loadStockProducts(1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.stockLoading ? "Buscando..." : "Buscar") + " ")])]), _vm.stockLoading ? _c('div', {
    staticClass: "loading-box mt-5"
  }, [_vm._v(" Buscando produtos do estoque... ")]) : _vm.stockError ? _c('div', {
    staticClass: "presentation-alert presentation-alert--danger mt-5",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', [_c('strong', [_vm._v("Falha ao consultar o estoque.")]), _c('p', [_vm._v(_vm._s(_vm.stockError))]), _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold mt-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.loadStockProducts(1);
      }
    }
  }, [_vm._v(" Tentar novamente ")])])]) : !_vm.stockProducts.length ? _c('div', {
    staticClass: "loading-box mt-5"
  }, [_vm._v(" Nenhum produto encontrado com estes filtros. ")]) : _c('div', {
    staticClass: "stock-product-list mt-5"
  }, _vm._l(_vm.stockProducts, function (product) {
    return _c('button', {
      key: "estoque-".concat(product.productId),
      staticClass: "stock-product-card",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selectStockProduct(product);
        }
      }
    }, [product.imageUrl ? _c('img', {
      attrs: {
        "src": product.imageUrl,
        "alt": ""
      }
    }) : _c('span', {
      staticClass: "stock-product-card__initials"
    }, [_vm._v(" " + _vm._s(product.initials) + " ")]), _c('span', {
      staticClass: "stock-product-card__body"
    }, [_c('strong', [_vm._v(_vm._s(product.name))]), _c('small', [_vm._v(" " + _vm._s(product.code || "Sem código") + " · " + _vm._s(product.groupName || "Sem categoria") + " ")]), _c('small', [_vm._v(" " + _vm._s(_vm.formatMoney(product.priceCents)) + " · " + _vm._s(product.restaurante ? "Restaurante ativo" : "Habilitar restaurante") + " ")]), product.quantity !== null && Number(product.quantity) <= 0 ? _c('small', {
      staticClass: "text-warning"
    }, [_vm._v(" Estoque zerado — pode configurar, mas confira antes de vender. ")]) : _vm._e()]), _c('span', {
      staticClass: "label label-inline",
      class: product.active ? 'label-light-success' : 'label-light-warning'
    }, [_vm._v(" " + _vm._s(product.active ? "Ativo" : "Somente rascunho") + " ")])]);
  }), 0), _vm.stockMeta.lastPage > 1 ? _c('div', {
    staticClass: "stock-pagination mt-5"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.stockMeta.page <= 1 || _vm.stockLoading
    },
    on: {
      "click": function click($event) {
        return _vm.loadStockProducts(_vm.stockMeta.page - 1);
      }
    }
  }, [_vm._v(" Anterior ")]), _c('span', [_vm._v("Página " + _vm._s(_vm.stockMeta.page) + " de " + _vm._s(_vm.stockMeta.lastPage))]), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.stockMeta.page >= _vm.stockMeta.lastPage || _vm.stockLoading
    },
    on: {
      "click": function click($event) {
        return _vm.loadStockProducts(_vm.stockMeta.page + 1);
      }
    }
  }, [_vm._v(" Próxima ")])]) : _vm._e()]) : _c('div', [_c('button', {
    staticClass: "btn btn-link pl-0 mb-4",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.publicationForm = null;
      }
    }
  }, [_vm._v(" ← Voltar para a busca ")]), _c('div', {
    staticClass: "publisher-product-summary"
  }, [_c('span', [_vm._v(_vm._s(_vm.publicationForm.initials))]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.publicationForm.name))]), _c('small', [_vm._v(" " + _vm._s(_vm.publicationForm.code || "Sem código") + " · " + _vm._s(_vm.formatMoney(_vm.publicationForm.priceCents)) + " ")])])]), _c('div', {
    staticClass: "modal-control-grid mt-6"
  }, [_c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Preparação operacional")]), _c('label', {
    staticClass: "checkbox-line mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicationForm.noPreparation,
      expression: "publicationForm.noPreparation"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.publicationForm.noPreparation) ? _vm._i(_vm.publicationForm.noPreparation, null) > -1 : _vm.publicationForm.noPreparation
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.publicationForm.noPreparation,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.publicationForm, "noPreparation", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.publicationForm, "noPreparation", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.publicationForm, "noPreparation", $$c);
        }
      }, _vm.onPublicationPreparationChange]
    }
  }), _c('span', [_vm._v("Sem preparo")])]), _c('div', {
    staticClass: "destination-picker",
    class: {
      disabled: _vm.publicationForm.noPreparation
    }
  }, [_c('label', {
    staticClass: "checkbox-line"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicationForm.destinations,
      expression: "publicationForm.destinations"
    }],
    attrs: {
      "type": "checkbox",
      "value": "cozinha",
      "disabled": _vm.publicationForm.noPreparation
    },
    domProps: {
      "checked": Array.isArray(_vm.publicationForm.destinations) ? _vm._i(_vm.publicationForm.destinations, "cozinha") > -1 : _vm.publicationForm.destinations
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.publicationForm.destinations,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "cozinha",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.publicationForm, "destinations", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.publicationForm, "destinations", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.publicationForm, "destinations", $$c);
        }
      }
    }
  }), _c('span', [_vm._v("Cozinha")])]), _c('label', {
    staticClass: "checkbox-line"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicationForm.destinations,
      expression: "publicationForm.destinations"
    }],
    attrs: {
      "type": "checkbox",
      "value": "bar",
      "disabled": _vm.publicationForm.noPreparation
    },
    domProps: {
      "checked": Array.isArray(_vm.publicationForm.destinations) ? _vm._i(_vm.publicationForm.destinations, "bar") > -1 : _vm.publicationForm.destinations
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.publicationForm.destinations,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "bar",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.publicationForm, "destinations", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.publicationForm, "destinations", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.publicationForm, "destinations", $$c);
        }
      }
    }
  }), _c('span', [_vm._v("Bar")])])]), _c('small', [_vm._v("Bar e Cozinha podem ser combinados. Sem preparo é exclusivo.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Categoria")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicationForm.categoryId,
      expression: "publicationForm.categoryId"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.publicationForm, "categoryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._l(_vm.categories, function (category) {
    return _c('option', {
      key: "publicar-categoria-".concat(category.id),
      domProps: {
        "value": category.id
      }
    }, [_vm._v(" " + _vm._s(category.name) + " ")]);
  })], 2), _c('button', {
    staticClass: "btn btn-link btn-sm pl-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openCategoryModal(null, true);
      }
    }
  }, [_vm._v(" + Nova categoria ")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Canais")]), _vm._l(_vm.publicationChannelOptions, function (channel) {
    return _c('label', {
      key: channel.value,
      staticClass: "checkbox-line mb-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.publicationForm.channels,
        expression: "publicationForm.channels"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": channel.value,
        "checked": Array.isArray(_vm.publicationForm.channels) ? _vm._i(_vm.publicationForm.channels, channel.value) > -1 : _vm.publicationForm.channels
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.publicationForm.channels,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = channel.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.publicationForm, "channels", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.publicationForm, "channels", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.publicationForm, "channels", $$c);
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(channel.label))])]);
  })], 2), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', {
    staticClass: "checkbox-line"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicationForm.published,
      expression: "publicationForm.published"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.publicationForm.active
    },
    domProps: {
      "checked": Array.isArray(_vm.publicationForm.published) ? _vm._i(_vm.publicationForm.published, null) > -1 : _vm.publicationForm.published
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.publicationForm.published,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.publicationForm, "published", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.publicationForm, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.publicationForm, "published", $$c);
        }
      }
    }
  }), _c('span', [_vm._v("Publicar agora nos canais selecionados")])]), !_vm.publicationForm.active ? _c('small', {
    staticClass: "text-warning"
  }, [_vm._v(" Produto inativo será salvo como rascunho e precisará ser ativado no cadastro antes da publicação. ")]) : _vm._e()])]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioProductPublisher');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('product-publication')
    },
    on: {
      "click": _vm.publishStockProduct
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("product-publication") ? "Salvando..." : _vm.publicationForm.active && _vm.publicationForm.published ? "Salvar e publicar" : "Salvar como rascunho") + " ")])])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioCategory",
      "title": _vm.categoryForm && _vm.categoryForm.id ? 'Editar categoria' : 'Nova categoria',
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.closeEntityDraft('category');
      }
    }
  }, [_vm.categoryForm ? _c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Nome do grupo e da categoria")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.categoryForm.name,
      expression: "categoryForm.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "120"
    },
    domProps: {
      "value": _vm.categoryForm.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.categoryForm, "name", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('small', [_vm._v("O nome também será usado no cadastro, salão e garçom.")])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Descrição pública")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.categoryForm.description,
      expression: "categoryForm.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "maxlength": "1000"
    },
    domProps: {
      "value": _vm.categoryForm.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.categoryForm, "description", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Ordem")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.categoryForm.order,
      expression: "categoryForm.order",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": _vm.categoryForm.order
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.categoryForm, "order", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Categoria ativa")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.categoryForm.visible,
      expression: "categoryForm.visible"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.categoryForm.visible) ? _vm._i(_vm.categoryForm.visible, null) > -1 : _vm.categoryForm.visible
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.categoryForm.visible,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.categoryForm, "visible", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.categoryForm, "visible", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.categoryForm, "visible", $$c);
        }
      }
    }
  }), _c('span')])])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Exibir nos canais")]), _vm._l(_vm.publicationChannelOptions, function (channel) {
    return _c('label', {
      key: "category-".concat(channel.value),
      staticClass: "checkbox-line mb-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.categoryForm.channels,
        expression: "categoryForm.channels"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": channel.value,
        "checked": Array.isArray(_vm.categoryForm.channels) ? _vm._i(_vm.categoryForm.channels, channel.value) > -1 : _vm.categoryForm.channels
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.categoryForm.channels,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = channel.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.categoryForm, "channels", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.categoryForm, "channels", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.categoryForm, "channels", $$c);
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(channel.label))])]);
  }), _c('small', [_vm._v(" Retirar um canal pausa somente a exposição da categoria nele; o grupo e seus produtos continuam disponíveis nos demais fluxos. ")])], 2)]) : _vm._e(), _c('div', {
    staticClass: "shared-impact-note mt-5"
  }, [_c('i', {
    staticClass: "flaticon-warning-sign"
  }), _c('span', [_vm._v("Salvar o nome altera o grupo compartilhado. A visibilidade continua específica do cardápio.")])]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioCategory');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('category')
    },
    on: {
      "click": _vm.saveCategory
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("category") ? "Salvando..." : "Salvar categoria") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioVariantCreator",
      "title": "Nova variante",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "variant-type-grid"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectVariantType('pizza');
      }
    }
  }, [_c('strong', [_vm._v("Pizza")]), _c('span', [_vm._v("Tamanhos, sabores, regra do sabor mais caro e bordas.")])]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selectVariantType('commercial');
      }
    }
  }, [_c('strong', [_vm._v("Variação comercial reutilizável")]), _c('span', [_vm._v("Tamanho, ponto ou outra escolha aplicada a produtos e categorias.")])])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioPromotions",
      "title": "Promoção comercial",
      "size": "xl",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closePromotionDraft
    }
  }, [_c('div', {
    staticClass: "promotion-preset-grid mb-6"
  }, _vm._l(_vm.promotionPresetOptions, function (preset) {
    return _c('button', {
      key: preset.value,
      class: {
        'promotion-preset-active': _vm.promotionForm.preset === preset.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.applyPromotionPreset(preset.value);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(preset.label))]), _c('span', [_vm._v(_vm._s(preset.description))])]);
  }), 0), _c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Título da promoção")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.name,
      expression: "promotionForm.name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.promotionForm.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "name", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Ex.: Terça da pizza, Combo do almoço, Semana do burger.")]), _vm.fieldError('nome') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("nome")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Subtítulo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.subtitle,
      expression: "promotionForm.subtitle"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.promotionForm.subtitle
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "subtitle", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Texto curto que aparece abaixo do título da campanha.")])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Descrição comercial")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.description,
      expression: "promotionForm.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": _vm.promotionForm.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "description", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Onde aparece")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.targetType,
      expression: "promotionForm.targetType"
    }],
    staticClass: "form-control",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.promotionForm, "targetType", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.onPromotionTargetTypeChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "produto"
    }
  }, [_vm._v("Produto específico")]), _c('option', {
    attrs: {
      "value": "categoria"
    }
  }, [_vm._v("Categoria inteira")]), _c('option', {
    attrs: {
      "value": "cardapio"
    }
  }, [_vm._v("Todo o cardápio")])])]), _vm.promotionForm.targetType === 'produto' ? _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Produto principal")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.productId,
      expression: "promotionForm.productId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.promotionForm, "productId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.syncPromotionPreviousPriceFromProduct]
    }
  }, _vm._l(_vm.publishedProducts, function (product) {
    return _c('option', {
      key: product.id,
      domProps: {
        "value": product.id
      }
    }, [_vm._v(" " + _vm._s(product.name) + " ")]);
  }), 0), _c('small', [_vm._v("Item principal da campanha.")])]) : _vm._e(), _vm.promotionForm.targetType === 'produto' && _vm.promotionVariantOptions.length ? _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tamanho ou variante")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.variantKey,
      expression: "promotionForm.variantKey"
    }],
    staticClass: "form-control",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.promotionForm, "variantKey", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.syncPromotionPreviousPriceFromProduct]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione a variante")]), _vm._l(_vm.promotionVariantOptions, function (variant) {
    return _c('option', {
      key: variant.key,
      domProps: {
        "value": variant.key
      }
    }, [_vm._v(" " + _vm._s(variant.label) + " · " + _vm._s(_vm.formatMoney(variant.priceCents)) + " ")]);
  })], 2), _c('small', [_vm._v(" A promoção será aplicada somente ao tamanho ou variante escolhido. ")])]) : _vm._e(), _vm.promotionForm.targetType === 'categoria' ? _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Categoria")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.categoryId,
      expression: "promotionForm.categoryId"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.promotionForm, "categoryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.categories, function (category) {
    return _c('option', {
      key: category.id,
      domProps: {
        "value": category.id
      }
    }, [_vm._v(" " + _vm._s(category.name) + " ")]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Imagem da vitrine")]), _c('div', {
    staticClass: "promotion-image-row"
  }, [_c('div', {
    staticClass: "promotion-image-preview"
  }, [_vm.promotionImagePreview ? _c('img', {
    attrs: {
      "src": _vm.promotionImagePreview,
      "alt": "Prévia da promoção"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.promotionForm.name || "Promoção"))])]), _c('div', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg,image/png,image/webp"
    },
    on: {
      "change": _vm.onPromotionImageSelected
    }
  }), _c('small', [_vm._v(" JPG, PNG ou WebP, até 5 MB. Use uma imagem horizontal para a vitrine de campanhas. ")])])])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tipo de desconto")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.discountType,
      expression: "promotionForm.discountType"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.promotionForm, "discountType", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "valor"
    }
  }, [_vm._v("Valor fixo")]), _c('option', {
    attrs: {
      "value": "percentual"
    }
  }, [_vm._v("Percentual")])])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.promotionForm.discountType === "percentual" ? "Percentual de desconto" : "Valor de desconto") + " ")]), _vm.promotionForm.discountType === 'percentual' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.promotionForm.discountPercent,
      expression: "promotionForm.discountPercent",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "min": "0",
      "max": "100",
      "type": "number"
    },
    domProps: {
      "value": _vm.promotionForm.discountPercent
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "discountPercent", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }) : _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.promotionForm.discountText,
      callback: function callback($$v) {
        _vm.$set(_vm.promotionForm, "discountText", $$v);
      },
      expression: "promotionForm.discountText"
    }
  }, 'money', _vm.moneyOptions, false)), _c('small', [_vm._v("O backend recalcula o preço final no checkout.")])], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Preço anterior exibido")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.promotionForm.previousPriceText,
      callback: function callback($$v) {
        _vm.$set(_vm.promotionForm, "previousPriceText", $$v);
      },
      expression: "promotionForm.previousPriceText"
    }
  }, 'money', _vm.moneyOptions, false)), _c('small', [_vm._v("Preenchido com o preço atual do produto selecionado.")])], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Preço promocional exibido")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.promotionForm.promotionalPriceText,
      callback: function callback($$v) {
        _vm.$set(_vm.promotionForm, "promotionalPriceText", $$v);
      },
      expression: "promotionForm.promotionalPriceText"
    }
  }, 'money', _vm.moneyOptions, false)), _c('small', [_vm._v(" Quando informado para um produto, calculamos o desconto a partir do preço atual. ")])], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Início")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.start,
      expression: "promotionForm.start"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.promotionForm.start
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "start", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Fim")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.end,
      expression: "promotionForm.end"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.promotionForm.end
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "end", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Chamada curta do banner")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.bannerText,
      expression: "promotionForm.bannerText"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.promotionForm.bannerText
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "bannerText", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Chamada curta para aparecer na vitrine do cardápio.")])]), _vm.promotionForm.preset === 'compre_ganhe' ? _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("O que o cliente ganha")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.giftText,
      expression: "promotionForm.giftText"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.promotionForm.giftText
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.promotionForm, "giftText", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Ex.: Ganhe uma bebida, sobremesa ou borda grátis.")])]) : _vm._e(), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Dias da semana")]), _c('div', {
    staticClass: "weekday-picker"
  }, _vm._l(_vm.weekdays, function (day) {
    return _c('label', {
      key: day.value
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.promotionForm.weekdays,
        expression: "promotionForm.weekdays"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": day.value,
        "checked": Array.isArray(_vm.promotionForm.weekdays) ? _vm._i(_vm.promotionForm.weekdays, day.value) > -1 : _vm.promotionForm.weekdays
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.promotionForm.weekdays,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = day.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.promotionForm, "weekdays", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.promotionForm, "weekdays", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.promotionForm, "weekdays", $$c);
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(day.label))])]);
  }), 0), _c('small', [_vm._v("Sem seleção significa disponível em todos os dias.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Promoção ativa")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.promotionForm.enabled,
      expression: "promotionForm.enabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.promotionForm.enabled) ? _vm._i(_vm.promotionForm.enabled, null) > -1 : _vm.promotionForm.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.promotionForm.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.promotionForm, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.promotionForm, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.promotionForm, "enabled", $$c);
        }
      }
    }
  }), _c('span')])])])]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioPromotions');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('promotion')
    },
    on: {
      "click": _vm.savePromotion
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("promotion") ? "Salvando..." : "Salvar promoção") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioCoupon",
      "title": "Cupom",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.closeEntityDraft('coupon');
      }
    }
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Código")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.couponForm.code,
      expression: "couponForm.code"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.couponForm.code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.couponForm, "code", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Ex.: PIZZA10, RETIRA5, CLIENTE20.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Nome interno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.couponForm.name,
      expression: "couponForm.name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.couponForm.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.couponForm, "name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tipo de desconto")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.couponForm.discountType,
      expression: "couponForm.discountType"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.couponForm, "discountType", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "valor"
    }
  }, [_vm._v("Valor fixo")]), _c('option', {
    attrs: {
      "value": "percentual"
    }
  }, [_vm._v("Percentual")])])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Desconto")]), _vm.couponForm.discountType === 'percentual' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.couponForm.discountPercent,
      expression: "couponForm.discountPercent",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "min": "0",
      "max": "100",
      "type": "number"
    },
    domProps: {
      "value": _vm.couponForm.discountPercent
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.couponForm, "discountPercent", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }) : _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.couponForm.discountText,
      callback: function callback($$v) {
        _vm.$set(_vm.couponForm, "discountText", $$v);
      },
      expression: "couponForm.discountText"
    }
  }, 'money', _vm.moneyOptions, false))], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Pedido mínimo")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.couponForm.minimumText,
      callback: function callback($$v) {
        _vm.$set(_vm.couponForm, "minimumText", $$v);
      },
      expression: "couponForm.minimumText"
    }
  }, 'money', _vm.moneyOptions, false))], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Limite total de uso")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.couponForm.totalLimit,
      expression: "couponForm.totalLimit",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": _vm.couponForm.totalLimit
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.couponForm, "totalLimit", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Início")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.couponForm.start,
      expression: "couponForm.start"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.couponForm.start
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.couponForm, "start", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Fim")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.couponForm.end,
      expression: "couponForm.end"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.couponForm.end
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.couponForm, "end", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Cupom ativo")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.couponForm.enabled,
      expression: "couponForm.enabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.couponForm.enabled) ? _vm._i(_vm.couponForm.enabled, null) > -1 : _vm.couponForm.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.couponForm.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.couponForm, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.couponForm, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.couponForm, "enabled", $$c);
        }
      }
    }
  }), _c('span')])])])]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioCoupon');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('coupon')
    },
    on: {
      "click": _vm.saveCoupon
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("coupon") ? "Salvando..." : "Salvar cupom") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioCombo",
      "title": "Combo",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.closeEntityDraft('combo');
      }
    }
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Produto publicado")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.comboForm.productId,
      expression: "comboForm.productId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.comboForm, "productId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.comboMainProductChanged]
    }
  }, _vm._l(_vm.publishedProducts, function (product) {
    return _c('option', {
      key: product.id,
      domProps: {
        "value": product.id
      }
    }, [_vm._v(" " + _vm._s(product.name) + " ")]);
  }), 0), _c('small', [_vm._v("Este produto passa a representar o combo no cardápio.")])]), _vm.comboPizzaSizes(_vm.comboForm.productId).length ? _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tamanho da primeira pizza")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.comboForm.pizzaSizeSlug,
      expression: "comboForm.pizzaSizeSlug"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.comboForm, "pizzaSizeSlug", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Cliente escolhe o tamanho")]), _vm._l(_vm.comboPizzaSizes(_vm.comboForm.productId), function (size) {
    return _c('option', {
      key: size.id || size.slug,
      domProps: {
        "value": size.slug
      }
    }, [_vm._v(" " + _vm._s(size.nome) + " ")]);
  })], 2), _c('small', [_vm._v("Defina o tamanho incluído no preço do combo.")])]) : _vm._e(), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Nome do combo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.comboForm.name,
      expression: "comboForm.name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.comboForm.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.comboForm, "name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Descrição")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.comboForm.description,
      expression: "comboForm.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": _vm.comboForm.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.comboForm, "description", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Preço do combo")]), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.comboForm.priceText,
      callback: function callback($$v) {
        _vm.$set(_vm.comboForm, "priceText", $$v);
      },
      expression: "comboForm.priceText"
    }
  }, 'money', _vm.moneyOptions, false))], 1), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Combo ativo")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.comboForm.enabled,
      expression: "comboForm.enabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.comboForm.enabled) ? _vm._i(_vm.comboForm.enabled, null) > -1 : _vm.comboForm.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.comboForm.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.comboForm, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.comboForm, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.comboForm, "enabled", $$c);
        }
      }
    }
  }), _c('span')])])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Composição")]), _c('small', {
    staticClass: "d-block mb-3 text-muted"
  }, [_vm._v(" O cliente escolhe os sabores da pizza principal primeiro. Se o tamanho não estiver fixo, ele também escolhe o tamanho. Adicione aqui a segunda pizza e os demais produtos do combo. ")]), _vm._l(_vm.comboForm.items, function (item, index) {
    return _c('div', {
      key: item.chave,
      staticClass: "d-flex align-items-start mb-3"
    }, [_c('div', {
      staticClass: "flex-grow-1 mr-3"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.productId,
        expression: "item.productId"
      }],
      staticClass: "form-control",
      on: {
        "change": [function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(item, "productId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }, function ($event) {
          return _vm.comboCompositionProductChanged(item);
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Selecione o produto")]), _vm._l(_vm.comboCompositionProducts, function (product) {
      return _c('option', {
        key: product.id,
        domProps: {
          "value": product.id
        }
      }, [_vm._v(" " + _vm._s(product.name) + " ")]);
    })], 2), _vm.comboPizzaSizes(item.productId).length ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: item.pizzaSizeSlug,
        expression: "item.pizzaSizeSlug"
      }],
      staticClass: "form-control mt-2",
      on: {
        "change": [function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(item, "pizzaSizeSlug", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }, function ($event) {
          return _vm.comboCompositionSizeChanged(item);
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Cliente escolhe o tamanho")]), _vm._l(_vm.comboPizzaSizes(item.productId), function (size) {
      return _c('option', {
        key: size.id || size.slug,
        domProps: {
          "value": size.slug
        }
      }, [_vm._v(" Tamanho fixo: " + _vm._s(size.nome) + " ")]);
    })], 2) : _vm._e(), item.pizzaSizeSlug && _vm.comboPizzaFlavors(item.productId, item.pizzaSizeSlug).length ? _c('div', {
      staticClass: "mt-2"
    }, [_c('label', {
      staticClass: "mb-1"
    }, [_vm._v("Sabores disponíveis nesta pizza")]), _c('small', {
      staticClass: "d-block text-muted mb-2"
    }, [_vm._v(" Sem seleção, todos os sabores desse tamanho ficam disponíveis. ")]), _vm._l(_vm.comboPizzaFlavors(item.productId, item.pizzaSizeSlug), function (flavor) {
      return _c('label', {
        key: flavor.id || flavor.slug,
        staticClass: "d-block mb-1"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: item.pizzaFlavorSlugs,
          expression: "item.pizzaFlavorSlugs"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": flavor.slug,
          "checked": Array.isArray(item.pizzaFlavorSlugs) ? _vm._i(item.pizzaFlavorSlugs, flavor.slug) > -1 : item.pizzaFlavorSlugs
        },
        on: {
          "change": function change($event) {
            var $$a = item.pizzaFlavorSlugs,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = flavor.slug,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && _vm.$set(item, "pizzaFlavorSlugs", $$a.concat([$$v]));
              } else {
                $$i > -1 && _vm.$set(item, "pizzaFlavorSlugs", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.$set(item, "pizzaFlavorSlugs", $$c);
            }
          }
        }
      }), _vm._v(" " + _vm._s(flavor.nome) + " ")]);
    })], 2) : _vm._e(), _vm.comboCompositionHint(item.productId) ? _c('small', [_vm._v(" " + _vm._s(_vm.comboCompositionHint(item.productId)) + " ")]) : _vm._e()]), _c('div', {
      staticClass: "mr-3",
      staticStyle: {
        "width": "110px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: item.quantity,
        expression: "item.quantity",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0.001",
        "step": "1",
        "placeholder": "Qtd."
      },
      domProps: {
        "value": item.quantity
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(item, "quantity", _vm._n($event.target.value));
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    })]), _c('button', {
      staticClass: "btn btn-light-danger btn-icon",
      attrs: {
        "type": "button",
        "title": "Remover item"
      },
      on: {
        "click": function click($event) {
          return _vm.removeComboItem(index);
        }
      }
    }, [_c('i', {
      staticClass: "la la-trash"
    })])]);
  }), _c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addComboItem
    }
  }, [_vm._v(" Adicionar produto à composição ")]), _c('small', {
    staticClass: "d-block mt-2"
  }, [_vm._v(" Produtos com variações ou opções serão configurados pelo cliente ao pedir o combo. ")])], 2)]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioCombo');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('combo')
    },
    on: {
      "click": _vm.saveCombo
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("combo") ? "Salvando..." : "Salvar combo") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioCheckout",
      "title": "Pagamento presencial",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetCheckoutDraft
    }
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Dinheiro presencial")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkoutForm.cash,
      expression: "checkoutForm.cash"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkoutForm.cash) ? _vm._i(_vm.checkoutForm.cash, null) > -1 : _vm.checkoutForm.cash
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.checkoutForm.cash,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.checkoutForm, "cash", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.checkoutForm, "cash", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.checkoutForm, "cash", $$c);
        }
      }
    }
  }), _c('span')])]), _c('small', [_vm._v("Permite informar troco para entrega ou retirada.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Cartão/Pix no balcão")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkoutForm.card,
      expression: "checkoutForm.card"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkoutForm.card) ? _vm._i(_vm.checkoutForm.card, null) > -1 : _vm.checkoutForm.card
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.checkoutForm.card,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.checkoutForm, "card", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.checkoutForm, "card", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.checkoutForm, "card", $$c);
        }
      }
    }
  }), _c('span')])]), _c('small', [_vm._v(" Na retirada, o cliente verá “Cartão/Pix no balcão”. Na entrega, esta opção representa somente cartão na maquininha. ")])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Mensagem ao cliente")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkoutForm.message,
      expression: "checkoutForm.message"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "maxlength": "500"
    },
    domProps: {
      "value": _vm.checkoutForm.message
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.checkoutForm, "message", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Texto exibido antes de finalizar.")]), _vm.fieldError('mensagem') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("mensagem")) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_vm.checkoutDirty ? _c('span', {
    staticClass: "text-warning font-weight-bold mr-auto"
  }, [_vm._v(" Alterações não salvas ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelCheckout
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('checkout')
    },
    on: {
      "click": _vm.saveCheckout
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("checkout") ? "Salvando..." : "Salvar pagamento presencial") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioVisual",
      "title": "Aparência e mensagens",
      "size": "xl",
      "dialog-class": "cardapio-visual-dialog",
      "content-class": "cardapio-visual-content",
      "body-class": "cardapio-visual-body",
      "hide-footer": ""
    },
    on: {
      "shown": _vm.initVisualPreview,
      "hidden": function hidden($event) {
        return _vm.cancelVisual(false);
      }
    }
  }, [_c('div', {
    staticClass: "visual-editor"
  }, [_c('div', [_c('b-tabs', {
    attrs: {
      "pills": "",
      "content-class": "pt-5"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Marca",
      "active": ""
    }
  }, [_c('div', {
    staticClass: "visual-upload-card"
  }, [_c('label', [_vm._v("Logo do cardápio")]), _c('div', {
    staticClass: "visual-logo-preview"
  }, [_vm.visualLogoPreview ? _c('img', {
    attrs: {
      "src": _vm.visualLogoPreview,
      "alt": "Prévia da logo"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.config.name ? _vm.config.name[0] : "C"))])]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg,image/png,image/webp"
    },
    on: {
      "change": function change($event) {
        return _vm.onVisualImageSelected($event, 'logo');
      }
    }
  }), _c('small', [_vm._v(" JPG, PNG ou WebP, até 5 MB. Use uma imagem quadrada para topo, busca e checkout. ")]), _vm.fieldError('logo') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("logo")) + " ")]) : _vm._e(), _vm.visualLogoPreview ? _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.removeVisualImage('logo');
      }
    }
  }, [_vm._v(" Remover logo ")]) : _vm._e()])]), _c('b-tab', {
    attrs: {
      "title": "Imagens"
    }
  }, [_c('div', {
    staticClass: "visual-upload-card"
  }, [_c('label', [_vm._v("Capa do site")]), _c('div', {
    staticClass: "visual-cover-preview"
  }, [_vm.visualCoverPreview ? _c('img', {
    attrs: {
      "src": _vm.visualCoverPreview,
      "alt": "Prévia da capa"
    }
  }) : _c('div', [_c('strong', [_vm._v(_vm._s(_vm.config.name || "Cardápio Online"))]), _c('span', [_vm._v("Imagem principal exibida no topo do site.")])])]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg,image/png,image/webp"
    },
    on: {
      "change": function change($event) {
        return _vm.onVisualImageSelected($event, 'capa');
      }
    }
  }), _c('small', [_vm._v(" JPG, PNG ou WebP, até 5 MB. Prefira foto horizontal de ambiente, produto ou fachada. ")]), _vm.fieldError('capa') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("capa")) + " ")]) : _vm._e(), _vm.visualCoverPreview ? _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.removeVisualImage('capa');
      }
    }
  }, [_vm._v(" Remover capa ")]) : _vm._e()])]), _c('b-tab', {
    attrs: {
      "title": "Tema"
    }
  }, [_c('p', {
    staticClass: "visual-choice-label"
  }, [_vm._v("Temas prontos")]), _c('div', {
    staticClass: "theme-preset-grid"
  }, _vm._l(_vm.themePresets, function (preset) {
    return _c('button', {
      key: preset.id,
      staticClass: "theme-preset",
      class: {
        'theme-preset--active': _vm.selectedTheme === preset.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.applyThemePreset(preset);
        }
      }
    }, [_c('span', {
      staticClass: "theme-preset__colors"
    }, [_c('i', {
      style: {
        background: preset.primary
      }
    }), _c('i', {
      style: {
        background: preset.accent
      }
    }), _c('i', {
      style: {
        background: preset.background
      }
    })]), _c('strong', [_vm._v(_vm._s(preset.label))]), _c('small', [_vm._v(_vm._s(preset.description))])]);
  }), 0), _c('div', {
    staticClass: "advanced-theme-toggle mt-5"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.advancedTheme = !_vm.advancedTheme;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.advancedTheme ? "Ocultar modo avançado" : "Personalizar cores") + " ")])]), _c('div', {
    staticClass: "modal-control-grid"
  }, [_vm.advancedTheme ? _c('div', {
    staticClass: "modal-control-field color-control"
  }, [_c('label', [_vm._v("Cor principal")]), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.visualForm.primaryColor,
      expression: "visualForm.primaryColor"
    }],
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": _vm.visualForm.primaryColor
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "primaryColor", $event.target.value);
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.visualForm.primaryColor,
      expression: "visualForm.primaryColor",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': !_vm.isValidHexColor(_vm.visualForm.primaryColor)
    },
    attrs: {
      "maxlength": "7"
    },
    domProps: {
      "value": _vm.visualForm.primaryColor
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "primaryColor", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('small', [_vm._v("Botões principais, abas ativas e destaques.")])]) : _vm._e(), _vm.advancedTheme ? _c('div', {
    staticClass: "modal-control-field color-control"
  }, [_c('label', [_vm._v("Cor de apoio")]), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.visualForm.accentColor,
      expression: "visualForm.accentColor"
    }],
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": _vm.visualForm.accentColor
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "accentColor", $event.target.value);
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.visualForm.accentColor,
      expression: "visualForm.accentColor",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': !_vm.isValidHexColor(_vm.visualForm.accentColor)
    },
    attrs: {
      "maxlength": "7"
    },
    domProps: {
      "value": _vm.visualForm.accentColor
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "accentColor", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('small', [_vm._v("Banners, detalhes suaves e áreas promocionais.")])]) : _vm._e(), _vm.advancedTheme ? _c('div', {
    staticClass: "modal-control-field color-control"
  }, [_c('label', [_vm._v("Cor de fundo")]), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.visualForm.backgroundColor,
      expression: "visualForm.backgroundColor"
    }],
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": _vm.visualForm.backgroundColor
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "backgroundColor", $event.target.value);
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.visualForm.backgroundColor,
      expression: "visualForm.backgroundColor",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': !_vm.isValidHexColor(_vm.visualForm.backgroundColor)
    },
    attrs: {
      "maxlength": "7"
    },
    domProps: {
      "value": _vm.visualForm.backgroundColor
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "backgroundColor", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('small', [_vm._v("Fundo principal do cardápio público.")])]) : _vm._e()]), _vm.visualContrastWarning ? _c('div', {
    staticClass: "visual-warning"
  }, [_vm._v(" " + _vm._s(_vm.visualContrastWarning) + " ")]) : _vm._e(), _c('p', {
    staticClass: "visual-choice-label mt-6"
  }, [_vm._v("Estilo dos cards")]), _c('div', {
    staticClass: "visual-choice-grid"
  }, _vm._l(_vm.cardStyleOptions, function (style) {
    return _c('button', {
      key: style.value,
      staticClass: "visual-choice",
      class: {
        'visual-choice--active': _vm.visualForm.cardStyle === style.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.visualForm.cardStyle = style.value;
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(style.label))]), _c('span', [_vm._v(_vm._s(style.description))])]);
  }), 0), _c('p', {
    staticClass: "visual-choice-label mt-4"
  }, [_vm._v("Formato dos botões")]), _c('div', {
    staticClass: "visual-choice-grid"
  }, _vm._l(_vm.buttonStyleOptions, function (style) {
    return _c('button', {
      key: style.value,
      staticClass: "visual-choice",
      class: {
        'visual-choice--active': _vm.visualForm.buttonStyle === style.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.visualForm.buttonStyle = style.value;
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(style.label))]), _c('span', [_vm._v(_vm._s(style.description))])]);
  }), 0)]), _c('b-tab', {
    attrs: {
      "title": "Mensagens"
    }
  }, [_c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Sem produtos")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.visualForm.emptyText,
      expression: "visualForm.emptyText"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "500"
    },
    domProps: {
      "value": _vm.visualForm.emptyText
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "emptyText", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Aparece quando não houver itens disponíveis.")]), _vm.fieldError('empty_text') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("empty_text")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Erro ao carregar")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.visualForm.errorText,
      expression: "visualForm.errorText"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "500"
    },
    domProps: {
      "value": _vm.visualForm.errorText
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "errorText", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Aparece se o cardápio não abrir.")]), _vm.fieldError('error_text') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("error_text")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Acompanhamento")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.visualForm.trackingText,
      expression: "visualForm.trackingText"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "500"
    },
    domProps: {
      "value": _vm.visualForm.trackingText
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.visualForm, "trackingText", $event.target.value);
      }
    }
  }), _c('small', [_vm._v("Texto de apoio na tela de status do pedido.")]), _vm.fieldError('tracking_text') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("tracking_text")) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "shared-impact-note mt-4"
  }, [_c('i', {
    staticClass: "flaticon2-information"
  }), _c('span', [_vm._v(" Loja fechada é editada em Publicação e horários. A mensagem do checkout é editada em Pagamentos. ")])])]), _c('b-tab', {
    attrs: {
      "title": "Pré-visualização"
    }
  }, [_c('div', {
    staticClass: "modal-control-field mb-4"
  }, [_c('label', [_vm._v("Cenário da prévia")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.previewScenario,
      expression: "previewScenario"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.previewScenario = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.previewScenarios, function (scenario) {
    return _c('option', {
      key: scenario.value,
      domProps: {
        "value": scenario.value
      }
    }, [_vm._v(" " + _vm._s(scenario.label) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "visual-preview-note"
  }, [_vm._v(" A prévia ao lado é o próprio cardápio público, atualizado em tempo real com cores, estilos, imagens e mensagens enquanto você edita. ")])])], 1)], 1), _c('aside', {
    staticClass: "visual-live-preview-panel"
  }, [_c('header', {
    staticClass: "visual-live-preview-panel__header"
  }, [_c('div', [_c('strong', [_vm._v("Prévia mobile")]), _c('span', [_vm._v("Visualização real em 390 × 844 px")])]), _c('span', {
    staticClass: "visual-live-preview-panel__badge"
  }, [_vm._v("Ao vivo")])]), _c('div', {
    staticClass: "visual-live-preview"
  }, [_vm.visualPreviewSrc ? _c('iframe', {
    ref: "visualPreviewFrame",
    staticClass: "visual-live-preview__frame",
    attrs: {
      "src": _vm.visualPreviewSrc,
      "title": "Prévia mobile do cardápio",
      "loading": "lazy"
    },
    on: {
      "load": _vm.pushVisualPreviewTheme
    }
  }) : _c('div', {
    staticClass: "visual-live-preview__empty"
  }, [_c('strong', [_vm._v("Prévia indisponível")]), _c('span', [_vm._v(" Publique o cardápio (aba Publicação) para ver a prévia em tempo real aqui. ")])])])])]), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_vm.visualDirty ? _c('span', {
    staticClass: "text-warning font-weight-bold mr-auto"
  }, [_vm._v(" Alterações não salvas ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelVisual
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('visual') || !_vm.visualDirty || !_vm.visualColorsValid
    },
    on: {
      "click": _vm.saveVisual
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("visual") ? "Salvando..." : "Salvar visual") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioOptionProductPicker",
      "title": "Criar opção em produto",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "advanced-section-note"
  }, [_c('strong', [_vm._v("Escolha o produto")]), _c('span', [_vm._v(" Use este caminho para borda, adicionais, molhos, acompanhamentos ou remoções que só fazem sentido em um item específico. ")])]), _c('div', {
    staticClass: "option-product-picker"
  }, _vm._l(_vm.configuredProducts, function (product) {
    return _c('button', {
      key: product.id,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selectProductForOptionGroup(product);
        }
      }
    }, [product.imageUrl ? _c('img', {
      attrs: {
        "src": product.imageUrl,
        "alt": ""
      }
    }) : _c('span', [_vm._v(_vm._s(product.initials))]), _c('strong', [_vm._v(_vm._s(product.name))]), _c('small', [_vm._v(_vm._s(_vm.categoryName(product.categoryId)))])]);
  }), 0), !_vm.configuredProducts.length ? _c('div', {
    staticClass: "loading-box"
  }, [_vm._v(" Configure um produto para o cardápio ou salão antes de criar opções. ")]) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioOptionGroup",
      "title": _vm.optionGroupModalTitle,
      "size": "xl",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.closeEntityDraft('optionGroup');
      }
    }
  }, [_c('div', {
    staticClass: "advanced-section-note"
  }, [_c('strong', [_vm._v(_vm._s(_vm.optionGroupModalSubtitle))]), _c('span', [_vm._v(" " + _vm._s(_vm.optionGroupModalDescription) + " ")])]), _vm.optionGroupForm ? _c('div', {
    staticClass: "option-preset-panel"
  }, _vm._l(_vm.optionGroupPresets, function (preset) {
    return _c('button', {
      key: preset.key,
      class: {
        'option-preset-active': _vm.optionGroupPresetMatches(preset)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.applyOptionGroupPreset(preset.key);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(preset.label))]), _c('span', [_vm._v(_vm._s(preset.description))])]);
  }), 0) : _vm._e(), _vm.optionGroupForm ? _c('div', {
    staticClass: "modal-control-grid"
  }, [_vm.optionGroupForm.mode === 'produto' ? _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Produto")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.productName(_vm.optionGroupForm.cardapio_produto_id)
    }
  }), _c('small', [_vm._v(" Este grupo aparece somente neste produto. Para outro item, abra o produto correspondente no catálogo. ")])]) : _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Alcance global")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optionGroupForm.globalScope,
      expression: "optionGroupForm.globalScope"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.optionGroupForm, "globalScope", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "todos"
    }
  }, [_vm._v("Todo o cardápio")]), _c('option', {
    attrs: {
      "value": "categorias"
    }
  }, [_vm._v("Categorias selecionadas")]), _c('option', {
    attrs: {
      "value": "produtos"
    }
  }, [_vm._v("Produtos selecionados")])]), _c('small', [_vm._v("Grupo global não pertence a um produto específico.")])]), _vm.optionGroupForm.mode === 'global' && _vm.optionGroupForm.globalScope === 'produtos' ? _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Produtos que recebem este grupo")]), _c('div', {
    staticClass: "option-category-picker"
  }, _vm._l(_vm.configuredProducts, function (product) {
    return _c('label', {
      key: "opcao-produto-".concat(product.id),
      staticClass: "checkbox-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.optionGroupForm.produto_ids,
        expression: "optionGroupForm.produto_ids"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": product.id,
        "checked": Array.isArray(_vm.optionGroupForm.produto_ids) ? _vm._i(_vm.optionGroupForm.produto_ids, product.id) > -1 : _vm.optionGroupForm.produto_ids
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.optionGroupForm.produto_ids,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = product.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.optionGroupForm, "produto_ids", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.optionGroupForm, "produto_ids", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.optionGroupForm, "produto_ids", $$c);
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(product.name))])]);
  }), 0), _c('small', [_vm._v(" O grupo será reutilizado somente nos produtos marcados, sem criar novas combinações de estoque. ")])]) : _vm._e(), _vm.optionGroupForm.mode === 'global' && _vm.optionGroupForm.globalScope === 'categorias' ? _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Categorias que recebem este grupo")]), _c('div', {
    staticClass: "option-category-picker"
  }, _vm._l(_vm.categories, function (category) {
    return _c('label', {
      key: category.id,
      staticClass: "checkbox-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.optionGroupForm.categoria_ids,
        expression: "optionGroupForm.categoria_ids"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": category.id,
        "checked": Array.isArray(_vm.optionGroupForm.categoria_ids) ? _vm._i(_vm.optionGroupForm.categoria_ids, category.id) > -1 : _vm.optionGroupForm.categoria_ids
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.optionGroupForm.categoria_ids,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = category.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.optionGroupForm, "categoria_ids", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.optionGroupForm, "categoria_ids", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.optionGroupForm, "categoria_ids", $$c);
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(category.name))])]);
  }), 0), _c('small', [_vm._v(" Deixe como todo o cardápio quando a escolha deve aparecer em todos os produtos. ")])]) : _vm._e(), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Função do grupo")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optionGroupForm.papel,
      expression: "optionGroupForm.papel"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.optionGroupForm, "papel", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "complemento"
    }
  }, [_vm._v("Complemento ou adicional")]), _c('option', {
    attrs: {
      "value": "variante"
    }
  }, [_vm._v("Variação comercial")])]), _c('small', [_vm._v("Variação comercial não cria combinação de estoque.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Nome do grupo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optionGroupForm.nome,
      expression: "optionGroupForm.nome"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.optionGroupForm.nome
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.optionGroupForm, "nome", $event.target.value);
      }
    }
  }), _vm.fieldError('nome') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("nome")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Tipo")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optionGroupForm.tipo,
      expression: "optionGroupForm.tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.optionGroupForm, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.optionGroupTypes, function (type) {
    return _c('option', {
      key: type.value,
      domProps: {
        "value": type.value
      }
    }, [_vm._v(" " + _vm._s(type.label) + " ")]);
  }), 0), _c('small', [_vm._v(_vm._s(_vm.optionGroupTypeHelp))])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Mínimo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.optionGroupForm.minimo,
      expression: "optionGroupForm.minimo",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": _vm.optionGroupForm.minimo
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.optionGroupForm, "minimo", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Máximo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.optionGroupForm.maximo,
      expression: "optionGroupForm.maximo",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": _vm.optionGroupForm.maximo
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.optionGroupForm, "maximo", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Obrigatório")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optionGroupForm.obrigatorio,
      expression: "optionGroupForm.obrigatorio"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.optionGroupForm.obrigatorio) ? _vm._i(_vm.optionGroupForm.obrigatorio, null) > -1 : _vm.optionGroupForm.obrigatorio
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.optionGroupForm.obrigatorio,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.optionGroupForm, "obrigatorio", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.optionGroupForm, "obrigatorio", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.optionGroupForm, "obrigatorio", $$c);
        }
      }
    }
  }), _c('span')])])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Múltipla quantidade")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optionGroupForm.permite_quantidade,
      expression: "optionGroupForm.permite_quantidade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.optionGroupForm.permite_quantidade) ? _vm._i(_vm.optionGroupForm.permite_quantidade, null) > -1 : _vm.optionGroupForm.permite_quantidade
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.optionGroupForm.permite_quantidade,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.optionGroupForm, "permite_quantidade", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.optionGroupForm, "permite_quantidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.optionGroupForm, "permite_quantidade", $$c);
        }
      }
    }
  }), _c('span')])])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Ativo")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optionGroupForm.ativo,
      expression: "optionGroupForm.ativo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.optionGroupForm.ativo) ? _vm._i(_vm.optionGroupForm.ativo, null) > -1 : _vm.optionGroupForm.ativo
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.optionGroupForm.ativo,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.optionGroupForm, "ativo", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.optionGroupForm, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.optionGroupForm, "ativo", $$c);
        }
      }
    }
  }), _c('span')])])]), _c('div', {
    staticClass: "modal-control-field modal-control-field-wide"
  }, [_c('label', [_vm._v("Canais que usam este grupo")]), _c('div', {
    staticClass: "destination-picker"
  }, _vm._l(_vm.publicationChannelOptions, function (channel) {
    return _c('label', {
      key: "opcao-canal-".concat(channel.value),
      staticClass: "checkbox-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.optionGroupForm.canais,
        expression: "optionGroupForm.canais"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": channel.value,
        "checked": Array.isArray(_vm.optionGroupForm.canais) ? _vm._i(_vm.optionGroupForm.canais, channel.value) > -1 : _vm.optionGroupForm.canais
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.optionGroupForm.canais,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = channel.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.optionGroupForm, "canais", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.optionGroupForm, "canais", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.optionGroupForm, "canais", $$c);
          }
        }
      }
    }), _c('span', [_vm._v(_vm._s(channel.label))])]);
  }), 0)])]) : _vm._e(), _vm.optionGroupForm ? _c('div', {
    staticClass: "option-editor mt-6"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_c('div', [_c('h5', [_vm._v("Itens do grupo")]), _c('p', [_vm._v(" " + _vm._s(_vm.optionGroupItemHint) + " ")])]), _c('div', {
    staticClass: "toolbar-actions"
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addOptionItem
    }
  }, [_vm._v(" Adicionar opção manual ")])])]), _c('div', {
    staticClass: "bar-product-picker mb-5"
  }, [_c('div', [_c('strong', [_vm._v("Produtos do Bar e da Cozinha")]), _c('small', [_vm._v(" O preço acompanha o cadastro e será congelado no pedido. O item seguirá ao setor configurado no produto como item real, não como observação. ")])]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.operationalProductDestination,
      expression: "operationalProductDestination"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.operationalProductsLoading
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.operationalProductDestination = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.loadOperationalProducts]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Bar e Cozinha")]), _c('option', {
    attrs: {
      "value": "cozinha"
    }
  }, [_vm._v("Somente Cozinha")]), _c('option', {
    attrs: {
      "value": "bar"
    }
  }, [_vm._v("Somente Bar")])]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.operationalProductSearch,
      expression: "operationalProductSearch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Buscar produto operacional",
      "disabled": _vm.operationalProductsLoading
    },
    domProps: {
      "value": _vm.operationalProductSearch
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.loadOperationalProducts.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.operationalProductSearch = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn btn-light-dark",
    attrs: {
      "type": "button",
      "disabled": _vm.operationalProductsLoading
    },
    on: {
      "click": _vm.loadOperationalProducts
    }
  }, [_vm._v(" " + _vm._s(_vm.operationalProductsLoading ? "Buscando..." : "Buscar") + " ")])])]), _vm.operationalProductsError ? _c('p', {
    staticClass: "text-danger mb-0",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.operationalProductsError) + " ")]) : _vm._e(), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.operationalProductSelection,
      expression: "operationalProductSelection"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.operationalProductsLoading || !_vm.operationalProducts.length
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.operationalProductSelection = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione um produto")]), _vm._l(_vm.operationalProducts, function (product) {
    return _c('option', {
      key: "operational-".concat(product.productId),
      domProps: {
        "value": product.productId
      }
    }, [_vm._v(" " + _vm._s(product.name) + " · " + _vm._s(_vm.operationalDestinationLabel(product)) + " · " + _vm._s(_vm.formatMoney(product.priceCents)) + " ")]);
  })], 2), _c('button', {
    staticClass: "btn btn-light-dark font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.operationalProductsLoading || !_vm.operationalProductSelection
    },
    on: {
      "click": _vm.addOperationalProductOption
    }
  }, [_vm._v(" Adicionar produto vinculado ")])]), _vm._l(_vm.optionGroupForm.opcoes, function (option, index) {
    return _c('div', {
      key: option.localKey,
      staticClass: "option-editor-row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: option.nome,
        expression: "option.nome"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Nome da opção"
      },
      domProps: {
        "value": option.nome
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(option, "nome", $event.target.value);
        }
      }
    }), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: option.descricao,
        expression: "option.descricao"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Descrição curta"
      },
      domProps: {
        "value": option.descricao
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(option, "descricao", $event.target.value);
        }
      }
    }), _c('money', _vm._b({
      staticClass: "form-control",
      attrs: {
        "disabled": option.efeito_operacional === 'produto_adicional' || option.efeito_operacional === 'observacao' || _vm.optionGroupForm.tipo === 'remocao_sem_preco'
      },
      model: {
        value: option.precoText,
        callback: function callback($$v) {
          _vm.$set(option, "precoText", $$v);
        },
        expression: "option.precoText"
      }
    }, 'money', _vm.moneyOptions, false)), _c('details', {
      staticClass: "option-advanced-link"
    }, [_c('summary', [_vm._v("Comportamento operacional")]), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: option.efeito_operacional,
        expression: "option.efeito_operacional"
      }],
      staticClass: "form-control mb-2",
      on: {
        "change": [function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(option, "efeito_operacional", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }, function ($event) {
          return _vm.onOptionEffectChange(option);
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "modificador"
      }
    }, [_vm._v("Modificador do item")]), _c('option', {
      attrs: {
        "value": "produto_adicional"
      }
    }, [_vm._v("Produto adicional real")]), _c('option', {
      attrs: {
        "value": "observacao"
      }
    }, [_vm._v("Somente observação")])]), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: option.produto_id,
        expression: "option.produto_id"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": option.efeito_operacional !== 'produto_adicional'
      },
      on: {
        "change": [function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(option, "produto_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }, function ($event) {
          return _vm.onOptionLinkedProductChange(option);
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Sem vínculo interno")]), _vm._l(_vm.linkableProducts, function (product) {
      return _c('option', {
        key: "interno-".concat(product.productId),
        domProps: {
          "value": product.productId
        }
      }, [_vm._v(" " + _vm._s(product.name) + " ")]);
    })], 2)]), _c('label', {
      staticClass: "checkbox-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: option.disponivel,
        expression: "option.disponivel"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(option.disponivel) ? _vm._i(option.disponivel, null) > -1 : option.disponivel
      },
      on: {
        "change": function change($event) {
          var $$a = option.disponivel,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(option, "disponivel", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(option, "disponivel", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(option, "disponivel", $$c);
          }
        }
      }
    }), _vm._v(" Disponível ")]), _c('button', {
      staticClass: "btn btn-sm btn-light-danger font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removeOptionItem(index);
        }
      }
    }, [_vm._v(" Remover ")])], 1);
  })], 2) : _vm._e(), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioOptionGroup');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('option-group')
    },
    on: {
      "click": _vm.saveOptionGroup
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("option-group") ? "Salvando..." : "Salvar grupo") + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "modalCardapioPizza",
      "title": "Variante",
      "size": "xl",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.closeEntityDraft('pizza');
      }
    }
  }, [_vm.pizzaForm ? _c('div', {
    staticClass: "modal-control-grid"
  }, [_c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Produto publicado")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pizzaForm.cardapio_produto_id,
      expression: "pizzaForm.cardapio_produto_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.pizzaForm, "cardapio_produto_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.configuredProducts, function (product) {
    return _c('option', {
      key: product.id,
      domProps: {
        "value": product.id
      }
    }, [_vm._v(" " + _vm._s(product.name) + " ")]);
  }), 0), _c('small', [_vm._v("Este produto passa a pedir tamanho e sabores no site.")])]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Nome da variante")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pizzaForm.nome_template,
      expression: "pizzaForm.nome_template"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm.pizzaForm.nome_template
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.pizzaForm, "nome_template", $event.target.value);
      }
    }
  }), _vm.fieldError('nome_template') ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.fieldError("nome_template")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Máximo padrão de sabores")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.pizzaForm.max_sabores_padrao,
      expression: "pizzaForm.max_sabores_padrao",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": _vm.pizzaForm.max_sabores_padrao
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.pizzaForm, "max_sabores_padrao", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "modal-control-field"
  }, [_c('label', [_vm._v("Template ativo")]), _c('span', {
    staticClass: "switch switch-outline switch-icon switch-success"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pizzaForm.ativo,
      expression: "pizzaForm.ativo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pizzaForm.ativo) ? _vm._i(_vm.pizzaForm.ativo, null) > -1 : _vm.pizzaForm.ativo
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.pizzaForm.ativo,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.pizzaForm, "ativo", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.pizzaForm, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.pizzaForm, "ativo", $$c);
        }
      }
    }
  }), _c('span')])])])]) : _vm._e(), _vm.pizzaForm ? _c('div', {
    staticClass: "option-editor mt-6"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_c('div', [_c('h5', [_vm._v("Tamanhos")]), _c('p', [_vm._v(" Defina preço base e limite de sabores. O valor final usa somente o adicional do sabor de maior valor. ")])]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPizzaSize
    }
  }, [_vm._v(" Adicionar tamanho ")])]), _vm._l(_vm.pizzaForm.tamanhos, function (size, index) {
    return _c('div', {
      key: size.localKey,
      staticClass: "option-editor-row"
    }, [_c('label', {
      staticClass: "option-editor-cell"
    }, [_c('span', [_vm._v("Nome do tamanho")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: size.nome,
        expression: "size.nome"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Nome"
      },
      domProps: {
        "value": size.nome
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(size, "nome", $event.target.value);
        }
      }
    })]), _c('label', {
      staticClass: "option-editor-cell"
    }, [_c('span', [_vm._v("Preço base")]), _c('money', _vm._b({
      staticClass: "form-control",
      model: {
        value: size.precoText,
        callback: function callback($$v) {
          _vm.$set(size, "precoText", $$v);
        },
        expression: "size.precoText"
      }
    }, 'money', _vm.moneyOptions, false))], 1), _c('label', {
      staticClass: "option-editor-cell"
    }, [_c('span', [_vm._v("Máx. sabores")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: size.max_sabores,
        expression: "size.max_sabores",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "min": "1",
        "type": "number"
      },
      domProps: {
        "value": size.max_sabores
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(size, "max_sabores", _vm._n($event.target.value));
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    })]), _c('label', {
      staticClass: "option-editor-cell"
    }, [_c('span', [_vm._v("Fatias")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: size.fatias,
        expression: "size.fatias",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "min": "1",
        "type": "number",
        "placeholder": "Fatias"
      },
      domProps: {
        "value": size.fatias
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(size, "fatias", _vm._n($event.target.value));
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    })]), _c('label', {
      staticClass: "checkbox-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: size.ativo,
        expression: "size.ativo"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(size.ativo) ? _vm._i(size.ativo, null) > -1 : size.ativo
      },
      on: {
        "change": function change($event) {
          var $$a = size.ativo,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(size, "ativo", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(size, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(size, "ativo", $$c);
          }
        }
      }
    }), _vm._v(" Ativo ")]), _c('button', {
      staticClass: "btn btn-sm btn-light-danger font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removePizzaSize(index);
        }
      }
    }, [_vm._v(" Remover ")])]);
  })], 2) : _vm._e(), _vm.pizzaForm ? _c('div', {
    staticClass: "option-editor mt-6"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_c('div', [_c('h5', [_vm._v("Sabores")]), _c('p', [_vm._v(" Informe nome e preço de referência. Restrinja por tamanho somente quando o sabor não serve para todos. ")])]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPizzaFlavor
    }
  }, [_vm._v(" Adicionar sabor ")])]), _vm._l(_vm.pizzaForm.sabores, function (flavor, index) {
    return _c('div', {
      key: flavor.localKey,
      staticClass: "option-editor-row option-editor-row-wide"
    }, [_c('label', {
      staticClass: "option-editor-cell"
    }, [_c('span', [_vm._v("Nome do sabor")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: flavor.nome,
        expression: "flavor.nome"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Nome"
      },
      domProps: {
        "value": flavor.nome
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(flavor, "nome", $event.target.value);
        }
      }
    })]), _c('label', {
      staticClass: "option-editor-cell"
    }, [_c('span', [_vm._v("Descrição")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: flavor.descricao,
        expression: "flavor.descricao"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Descrição"
      },
      domProps: {
        "value": flavor.descricao
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(flavor, "descricao", $event.target.value);
        }
      }
    })]), _c('label', {
      staticClass: "option-editor-cell"
    }, [_c('span', [_vm._v("Preço do sabor")]), _c('money', _vm._b({
      staticClass: "form-control",
      model: {
        value: flavor.precoText,
        callback: function callback($$v) {
          _vm.$set(flavor, "precoText", $$v);
        },
        expression: "flavor.precoText"
      }
    }, 'money', _vm.moneyOptions, false))], 1), _c('label', {
      staticClass: "option-editor-cell"
    }, [_c('span', [_vm._v("Tamanhos disponíveis")]), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: flavor.tamanhos,
        expression: "flavor.tamanhos"
      }],
      staticClass: "form-control",
      attrs: {
        "multiple": ""
      },
      on: {
        "change": function change($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(flavor, "tamanhos", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }
      }
    }, _vm._l(_vm.pizzaForm.tamanhos, function (size) {
      return _c('option', {
        key: size.localKey,
        domProps: {
          "value": size.slug
        }
      }, [_vm._v(" " + _vm._s(size.nome || size.slug) + " ")]);
    }), 0)]), _c('label', {
      staticClass: "checkbox-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: flavor.disponivel,
        expression: "flavor.disponivel"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(flavor.disponivel) ? _vm._i(flavor.disponivel, null) > -1 : flavor.disponivel
      },
      on: {
        "change": function change($event) {
          var $$a = flavor.disponivel,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(flavor, "disponivel", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(flavor, "disponivel", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(flavor, "disponivel", $$c);
          }
        }
      }
    }), _vm._v(" Disponível ")]), _c('button', {
      staticClass: "btn btn-sm btn-light-danger font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removePizzaFlavor(index);
        }
      }
    }, [_vm._v(" Remover ")])]);
  })], 2) : _vm._e(), _vm.pizzaForm ? _c('div', {
    staticClass: "option-editor mt-6"
  }, [_c('div', {
    staticClass: "toolbar-line"
  }, [_c('div', [_c('h5', [_vm._v("Bordas")]), _c('p', [_vm._v("Cadastre bordas próprias da pizza e os tamanhos compatíveis.")])]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPizzaBorder
    }
  }, [_vm._v(" Adicionar borda ")])]), _vm._l(_vm.pizzaForm.bordas, function (border, index) {
    return _c('div', {
      key: border.localKey,
      staticClass: "option-editor-row option-editor-row-wide"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: border.nome,
        expression: "border.nome"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Nome"
      },
      domProps: {
        "value": border.nome
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(border, "nome", $event.target.value);
        }
      }
    }), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: border.descricao,
        expression: "border.descricao"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Descrição"
      },
      domProps: {
        "value": border.descricao
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(border, "descricao", $event.target.value);
        }
      }
    }), _c('money', _vm._b({
      staticClass: "form-control",
      model: {
        value: border.precoText,
        callback: function callback($$v) {
          _vm.$set(border, "precoText", $$v);
        },
        expression: "border.precoText"
      }
    }, 'money', _vm.moneyOptions, false)), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: border.tamanhos,
        expression: "border.tamanhos"
      }],
      staticClass: "form-control",
      attrs: {
        "multiple": ""
      },
      on: {
        "change": function change($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(border, "tamanhos", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }
      }
    }, _vm._l(_vm.pizzaForm.tamanhos, function (size) {
      return _c('option', {
        key: "borda-".concat(size.localKey),
        domProps: {
          "value": size.slug
        }
      }, [_vm._v(" " + _vm._s(size.nome || size.slug) + " ")]);
    }), 0), _c('label', {
      staticClass: "checkbox-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: border.disponivel,
        expression: "border.disponivel"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(border.disponivel) ? _vm._i(border.disponivel, null) > -1 : border.disponivel
      },
      on: {
        "change": function change($event) {
          var $$a = border.disponivel,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(border, "disponivel", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(border, "disponivel", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(border, "disponivel", $$c);
          }
        }
      }
    }), _vm._v(" Disponível ")]), _c('button', {
      staticClass: "btn btn-sm btn-light-danger font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removePizzaBorder(index);
        }
      }
    }, [_vm._v(" Remover ")])], 1);
  })], 2) : _vm._e(), _c('div', {
    staticClass: "modal-footer px-0 pb-0"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modalCardapioPizza');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving('pizza')
    },
    on: {
      "click": _vm.savePizza
    }
  }, [_vm._v(" " + _vm._s(_vm.isSaving("pizza") ? "Salvando..." : "Salvar variante") + " ")])])]), _c('catalog-image-crop-modal', {
    attrs: {
      "file": _vm.pendingImageFile,
      "aspect-ratio": 1,
      "min-crop-width": 800,
      "min-crop-height": 800,
      "max-published-width": 1200,
      "max-published-height": 1200,
      "output-quality": 0.88,
      "destination-label": "cardápio",
      "emit-cropped-file": ""
    },
    on: {
      "apply": _vm.onProductImageCropApplied,
      "cancel": _vm.cancelProductImageCrop
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Cardápio Digital ")]), _c('span', {
    staticClass: "text-muted mt-2 font-weight-bold font-size-sm"
  }, [_vm._v(" Catálogo, canais, ofertas, entrega e experiência do cliente ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "presentation-alert-icon"
  }, [_c('i', {
    staticClass: "flaticon-warning-sign"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "presentation-alert-icon"
  }, [_c('i', {
    staticClass: "flaticon2-hourglass-1"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('strong', [_vm._v("Carregando configurações reais...")]), _c('p', [_vm._v("Consultando canais, catálogo e regras de atendimento.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', [_vm._v("Venda online")]), _c('h5', [_vm._v("Cardápio Digital")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', [_vm._v("Pedido na mesa")]), _c('h5', [_vm._v("Self Pedido")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "shared-impact-note mt-5"
  }, [_c('i', {
    staticClass: "flaticon2-information"
  }), _c('span', [_vm._v(" A publicação controla nome, endereço público, agenda semanal e a única mensagem usada quando a loja estiver fechada. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h5', [_vm._v("Produtos do Cardápio Digital")]), _c('p', [_vm._v(" Publique produtos já cadastrados ou abra o cadastro oficial para criar um item novo com dados fiscais e tributários. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "shared-impact-note mb-5"
  }, [_c('i', {
    staticClass: "flaticon2-information"
  }), _c('span', [_vm._v(" Este catálogo é compartilhado com salão e garçom. Ajustes de preço, categoria ou disponibilidade podem afetar os dois usos. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Produto")]), _c('th', [_vm._v("Categoria")]), _c('th', [_vm._v("Preço no site")]), _c('th', [_vm._v("Preparo")]), _c('th', [_vm._v("Publicação")]), _c('th', [_vm._v("Status")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ações")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h5', [_vm._v("Categorias compartilhadas")]), _c('p', [_vm._v(" A organização abaixo vem dos grupos do cadastro de produtos. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "shared-impact-note mb-5"
  }, [_c('i', {
    staticClass: "flaticon-warning-sign"
  }), _c('span', [_vm._v(" Nome e movimentação pertencem ao grupo compartilhado com salão e garçom. Pausar aqui altera somente os canais escolhidos do cardápio. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h5', [_vm._v("Grupos globais")]), _c('p', [_vm._v(" Use quando a mesma escolha deve aparecer em todo o cardápio ou em categorias inteiras. Para borda, adicionais e acompanhamentos de um item específico, abra o produto no catálogo. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "option-scope-guide"
  }, [_c('article', [_c('span', [_vm._v("Global")]), _c('strong', [_vm._v("Vale para vários produtos")]), _c('p', [_vm._v(" Bom para molhos, talheres, sacola, observações ou escolhas que toda categoria compartilha. ")])]), _c('article', [_c('span', [_vm._v("Produto")]), _c('strong', [_vm._v("Fica dentro de um item")]), _c('p', [_vm._v(" Bom para borda de uma pizza, ponto da carne, remoção de ingrediente ou adicional daquele produto. ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h5', [_vm._v("Variantes de venda")]), _c('p', [_vm._v(" Configure pizzas ou escolhas reutilizáveis, como tamanho e ponto. Variantes comerciais não criam combinações de estoque. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "delivery-team-card__eyebrow"
  }, [_vm._v("Equipe de entrega")]), _c('h5', [_vm._v("Entregadores")]), _c('p', [_vm._v(" Primeiro habilite a função no cadastro do usuário. Depois, vincule-o aqui para receber atribuições de entrega. Pausar remove o entregador das novas atribuições sem apagar o histórico. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', [_vm._v("Mensagens próprias")]), _c('strong', [_vm._v("Vazio, erro e acompanhamento")])]);
}];
export { render, staticRenderFns };